/*
 * OTTAR – SEASON 3 ONLY / APPROVED
 * Generated directly from Google Sheet master.
 * Source tab: Season 3 – råtekst
 * Filter: Season = 3 (including 3.0) AND Status = Approved AND Canon = Ja
 *
 * No Season 2 rows. No legacy JS library used as source.
 * Pair pools: flat [setup, payoff, ...]
 * openings/wisdom/endings/signs: single-string arrays
 */
window.OTTAR = {
  "observations": [
    "Det e bestandig en som kommer ned på kaia med en ny plan.",
    "Det e sjelden den samme som må rydda opp etterpå.",
    "Kaffe tel alle e den delen av enhver plan som sjelden møter motstand.",
    "Resten kan diskuteres når koppen e tom.",
    "Instruksjonen tel vinsjen blei behandla som et forslag.",
    "Garantien hadde dessverre lest den som et krav.",
    "Det skulle ikkje bli dyrt.",
    "Det va før første skrue blei løsna.",
    "Når nån kommer sjøvåt inn i bua, treng de sjelden et foredrag om været.",
    "De treng kaffe og en tørr plass ved ovnen.",
    "Den våte oljehyra blei hengt opp uten spørsmål.",
    "Resten av historia kom i andre kaffekopp.",
    "Den tomme stolen ved kaffebordet blei ståanes heile vakta.",
    "Marta satte bærre en kopp ved sida av.",
    "Marta sa aldri at ho tok vare på folk.",
    "Ho fylte vedkorga før regnet kom.",
    "Ronny meinte et nei bærre va starten på en forhandling.",
    "Marta låste bua.",
    "Det e klokt å la folk snakk ferdig.",
    "Ofte oppdaga de sjøl at planen ikkje tåla dagslys.",
    "Johannes svarte ikkje da han blei spurt.",
    "Han fylte koppen og såg ut sundet. Det va tydelig nok.",
    "Folk som sei alt går bra, bør vurderes sammen med stemmen de sei det med.",
    "Bamse e ofte bedre på den slags enn folk.",
    "Råd gitt før historia e ferdig, e som å knyt før båten ligg inntil.",
    "Du får det kanskje tel, men sjelden pent.",
    "Det finnes blikk som dømme hardere enn ord.",
    "Derfor e det greit å ha Bamse under bordet. Han tar sæ av den jobben.",
    "Han sa alt gikk bra tre ganga.",
    "På den fjerde va stemmen mindre overbevist.",
    "Folk som får snakk ferdig, bli ofte sittanes litt lenger ved kaffebordet.",
    "Det e fordi stillheta endelig føles trygg.",
    "Marta kunne sei nei uten å heve stemmen.",
    "Døra blei likevel ståanes åpen.",
    "En tom stol kan få folk tel å bli sittanes lenger enn de hadde tenkt.",
    "Fravær har sin egen tyngde."
  ],
  "kaiaStories": [
    "Snarveien tok heile dagen og to ekstra tau.",
    "Det va omtrent da vi skjønte at den va planlagt av en optimist.",
    "Midlertidig betyr ofte resten av levetida på kaia.",
    "Det kommer an på kor godt stripsen sitt.",
    "Når nån sei at ingen må få panikk på kaia, får panikken endelig en idé.",
    "Før det hadde ingen tenkt på den.",
    "Kaffe bli satt over før spørsmålet kommer.",
    "Det e ikkje tankelesing, bærre erfaring med folk.",
    "Det e ofte klokt å vent med rådan tel kaffen e drukket.",
    "Sannheta kommer sjelden i første slurk.",
    "Når en våt kar kommer inn og sei alt e under kontroll, sett du over kaffe før du begynn å tru på han.",
    "Den første som slutta å snakk, fant som regel feilen.",
    "Et fullt hus har ofte plass tel én tel.",
    "Det e ikkje golvarealet som avgjør, men kem som rydda fram stolen.",
    "Når en kar kommer sjøvåt inn i bua og ler litt for høyt, finn du fram ullkofta.",
    "Spørsmålan kan vent tel han slutta å frys.",
    "Når stillheta bli tung, rydda du plass ved bordet i bua.",
    "Folk snakka lættere når de ikkje må stå.",
    "Når stemmen sprekker litt, e det slutt på småpraten.",
    "Da sett du fram den andre kaffekoppen.",
    "Når en kar sei alt går bra litt for fort, veit kaia at kaffekjelen får en lang kveld.",
    "Det va da Marta satte over den store kaffekjelen."
  ],
  "livet": [
    "Han lånte et verktøy han ikkje visste navnet på.",
    "Selvtilliten hans va større enn garantien.",
    "Mål én gang og sag med overbevisning, så får andre måle resten etterpå.",
    "Det e en gammel metode, men ikkje en god en.",
    "Plan B e ofte å hente den som faktisk kan det.",
    "Det e en god plan, men en dyr måte å lær på.",
    "På kaia e begge hendern i lomman første tegn på at nån har tenkt å lede arbeidet.",
    "Det andre e at han begynn å peke.",
    "Sannheta kommer sjelden i første kaffekopp.",
    "Den må som regel bli varm nok før den tør å sette sæ ned.",
    "Et tydelig nei kan gjøre et problem mindre.",
    "Et uklart ja gir det ofte mat.",
    "Ronny slo på feil bryter og mørkla halve kaia i fem minutt.",
    "Ingen va sinte; sånne feil bli tel historia som varme oss når været ikkje gjør det.",
    "Folk sei tida går som ei ferge forbi.",
    "Hær på kaia ser vi at ho òg legg sæ tel, lag på lag, i hånda, båtan og blikket heimover."
  ],
  "kaffe": [
    "Det ordna sæ tel slutt, bærre ikkje på den måten planen lovte.",
    "Sånn e det ofte med både folk og fortøyning.",
    "Den andre kaffekoppen e ofte den ærligste.",
    "Først da slutte folk å forsvare planen og begynne å forklar den.",
    "Når nån sei alt e i orden litt for fort, sett over mer kaffe.",
    "Det e billigere enn å diskutere med løgn.",
    "I et fullt hus spør den klokeste kem som har spist.",
    "Resten kan forklares etterpå.",
    "Den som bærre skulle lån telefonen, treng ofte mat, kaffe og et håndkle.",
    "Telefonen va kanskje bærre ei unnskyldning.",
    "Kaffekoppen tel den som gikk, bli rydda tel slutt.",
    "Det e en liten måte å si at han fortsatt hør tel."
  ],
  "stikk": [
    "Nån ser muligheta i dårlig vær.",
    "Bamse ser etter le, og han tar sjelden feil.",
    "Han fant ei løsning ingen andre hadde sett.",
    "Det va fordi de andre hadde sett konsekvensan.",
    "Det finnes folk som aldri sei «ka sa æ».",
    "De træng ikkje, for stillheta gjør jobben."
  ],
  "vaeret": [
    "Det skulle spares tid.",
    "Resten av ettermiddagen blei brukt på å finne den igjen.",
    "skyan legg sæ lavt.",
    "Ronny stolte på oppholdet heilt tel vannet rann ned nakken."
  ],
  "batmotor": [
    "Prototypen såg ut som nåkka som burde fortøyes.",
    "Det va da vi skjønte at oppfinneren va fornøyd.",
    "Motoren sang skeivt, men Ronny meinte alt va normalt.",
    "Johannes svarte at håp e fint, men det smør ikkje lager.",
    "Motoren sleit med å ta turtall, og Marta spurte rolig om vi hadde sjekka diesel og filter.",
    "Johannes nikka og sa at den har prøvd å fortelle det i ei uke.",
    "Motoren hosta og tok ujevnt under første draget.",
    "Johannes nikka før vi rakk å bli bekymra; han kjente den lyden som et gammelt arr.",
    "Johannes la øret mot skottet og blei ståanes så stille at Bamse gjespa.",
    "Så stramma han ei klemme to hakk; irriteranes nok va det heile kuren.",
    "En gammel diesel lyge sjelden når han begynne å småbanke.",
    "Da bli alle de andre lydan i hodet plutselig høyere, og du finn verktøykassen før du finn ordan.",
    "Motoren daua som om nån dro ut kontakten midt i refrenget.",
    "Ronny skrudde ned radioen for å hør bedre på stillheta, som om ho trengte volum.",
    "Motoren døde midt i sundet, og alle stirra mistenksomt på været.",
    "Marta pekte på tankmåleren og sa at det e sjelden sjøen som overdrive, mest oss."
  ],
  "marta": [
    "Marta såg på den tomme stolen og fant fram et håndkle før nån rakk å forklar sæ.",
    "Ho visste at folk ofte trengte varme før de trengte spørsmål.",
    "Folk sa ofte at alt gikk bra.",
    "Marta spurte om de hadde spist, og det va som regel da sannheta kom fram.",
    "Nån kom våt inn døra og prøvde å le det bort.",
    "Marta fant fram tørre klær og venta med spørsmålan tel kaffen va varm.",
    "Marta sa at omsorg òg kunne være et nei.",
    "Ronny skjønte det va alvor da ho sa det uten å løfte stemmen.",
    "Marta hadde allerede funnet fram det som mangla.",
    "Ho visste at sannheta sjelden kom før andre kaffekopp.",
    "Kjøkkenet hos Marta kunne bli fullt på et øyeblikk.",
    "Hos Marta gikk ingen sulten heim, heller ikkje dem som sa de bærre skulle innom.",
    "Marta lot folk snakk ferdig.",
    "Når de endelig va tom for ord, gjorde det ene øyenbrynet hennes jobben.",
    "Marta satte kaffekanna på bordet.",
    "Ingen rakk å spørre før koppan begynte å fylles.",
    "Marta flytta kaffekanna nærmere Johannes.",
    "Det va sånn ho ba folk bli sittanes.",
    "Marta satte sukkeret midt på bordet.",
    "Resten fikk ordn sæ sjøl.",
    "Marta tok kaffekanna inn før vinden rakk den.",
    "Ho stolte meir på vindkastet enn på værmeldinga.",
    "Marta lot kaffen trekke litt lenger.",
    "Ingen protesterte.",
    "Marta fant fram ei ny pakke kaffe.",
    "Ho tok ingen sjanser.",
    "Marta satte fram heimelaga syltetøy.",
    "Glasset blei tomt før praten gjorde det.",
    "Marta la ferskt brød på fjøla.",
    "Kniven fant vegen sjøl.",
    "Kaffekjelen småprata med ovnen.",
    "Marta lot dem holde på.",
    "Marta fylte opp vedkorga før nån ba om det.",
    "Ho hadde lært at kulda alltid kom før folk va enige om den.",
    "Marta tørka av vinduskarmen.",
    "Regnet hadde lagt igjen en hilsen.",
    "Marta satte ei gryte på komfyren.",
    "Det lukta middag før nån rakk å klag.",
    "Marta satt sæ ikkje ned før alle andre hadde fått sitt.",
    "Da ho endelig satte sæ, va det ingen som hadde meir å be om.",
    "Marta fant fram kanel tel vaflene.",
    "Det blei stille rundt bordet.",
    "Marta la hånda på kaffekanna.",
    "Ho visste at den snart måtte fylles.",
    "Marta såg ut vinduet og nikka mot været.",
    "Ho hadde rekna rett igjen.",
    "Marta fant fram den blå emaljekoppen.",
    "Den hadde overlevd det meste.",
    "Marta hadde alt satt på kaffen før nån spurte.",
    "Ho hadde sett den forklaringa komme før folk fikk på sæ støvlan.",
    "Marta lo lavt.",
    "Det holdt at resten lo med.",
    "Marta bretta kjøkkenhåndkleet heilt beint.",
    "Det va hennes måte å få én ting tel å oppføre sæ.",
    "Bamse såg etter Marta.",
    "Ho hadde sikkert nåkka godt.",
    "Marta åpna vinduet.",
    "Måseskrik og lukt av tang fylte kjøkkenet.",
    "Marta tørka mel av hendern og satte over meir kaffe.",
    "Ho visste at tomme koppa begynne å stille spørsmål.",
    "Marta vaska kjøkkenbenken sjøl om den allerede va rein.",
    "Så satte ho kaffekanna tilbake akkurat der den sto.",
    "Marta fant fram den gamle kaffeboksen.",
    "Den va nesten like fast inventar som bordet.",
    "Marta satte sukkeret ved sida av kaffekanna.",
    "Ho visste at folk fant fram uten hjelp.",
    "Marta lufta kjøkkenet.",
    "Sjølufta tok over rommet.",
    "Marta fant fram vaffeljernet.",
    "Det trengtes ingen forklaring.",
    "Marta helsa med et smil før ho sa nåkka.",
    "Resten kom først da ho hadde sett kem som fortjente det.",
    "Marta sette loket på kaffikanna.",
    "Det va nok for denne runden.",
    "Marta tok fram syltagurka.",
    "Nån kom tel å bli glad.",
    "Marta satte ei gryte på ovnen.",
    "Lukta spredde sæ før varmen gjorde det.",
    "Marta satte fram heimelaga lefser.",
    "Fatet blei fort lættere.",
    "Marta nikka mot kaffekanna.",
    "Det trengtes ikkje fleire ord.",
    "Marta satte ei kanne saft på bordet.",
    "Ungan fant veien av sæ sjøl.",
    "Marta fant fram kortstokken.",
    "Regnet fikk bærre fortsette ute.",
    "Marta såg kveldssola treffe naustveggen.",
    "Ho sto der litt ekstra.",
    "Marta hengte opp et kjøkkenhåndkle tel tørk.",
    "Vinden tok jobben alvorlig.",
    "Marta fant fram sytråden.",
    "En knapp fikk bli ei stund tel.",
    "Marta la inn meir ved i ovnen.",
    "Kvelden fikk klar sæ sjøl.",
    "Marta fant fram et nytt stearinlys sjøl om det fortsatt va lyst ute.",
    "Ho hadde tenkt lenger fram enn lyset.",
    "Marta åpna vinduet på gløtt.",
    "Det va akkurat nok.",
    "Marta satte koppan tel tørk.",
    "De sto klar tel neste morgen.",
    "Marta hengte vottan tel tørk over ovnen.",
    "De hadde gjort jobben sin.",
    "Marta la et ullteppe over stolen.",
    "Kvelden kom tidlig nu.",
    "Marta fant fram den tjukke emaljekjelen.",
    "Suppa fikk god tid.",
    "Marta satte over meir kaffe.",
    "Kulda va grunn god nok.",
    "Marta åpna døra.",
    "Vårlufta hadde endelig funnet veien tilbake.",
    "Marta satte fram en bolle med kokte egg.",
    "Det blei færre for kvær som kom innom.",
    "Marta satte rabarbra tel koking.",
    "Lukta fylte heile kjøkkenet.",
    "Marta bar ut saft og glass.",
    "Ingen trengte å bli ropt på.",
    "Marta rydda av bordet, men lot kortstokken ligge.",
    "Det va tydelig at kvelden ikkje va ferdig.",
    "Læstan hang over ovnen og dryppa sakte.",
    "Det va sånn man såg at folk hadde kommet sæ heim.",
    "Lina blei egna ved kjøkkenbordet.",
    "Marta sa agnet satt bedre når skrytet holdt sæ ute.",
    "Marta satte kaffekjelen på da oljehyra kom inn døra.",
    "Resten av mannen fikk forklar sæ når han hadde tint.",
    "Marta rydda linebøtta uten å nevne kem som hadde rota.",
    "Ronny blei urolig av den typen stillhet.",
    "Marta la avisen i de våte støvlan.",
    "Ho reparerte sjelden folk direkte når omveien virka bedre.",
    "Marta satte den bulkete termosen midt på bordet.",
    "Ingen fikk skamme sæ over utstyret så lenge kaffen va varm.",
    "Marta ba skårungen sette sæ og holde kjeft.",
    "Suppa sto allerede foran plassen hans.",
    "Marta sa kaffekoppen ikkje va terapi.",
    "Ho fylte den likevel tre ganga.",
    "Marta kalte planen komplett idiotisk.",
    "Ho pakka feskekaka og kaffe tel dem før de dro.",
    "Marta sa det va slutt på tullpraten.",
    "Det betydde at ho hadde begynt å bli bekymra.",
    "Ronny sa han klarte sæ sjøl.",
    "Marta svarte at det va nettopp derfor ho blei.",
    "Marta ba han spise før han begynte å forklar.",
    "Ho hadde erfaring med både sult og dårlige avgjørelser.",
    "Marta ba dem slutt å lag helta av dårlig planlegging.",
    "Så behandla ho skrubbsåran som om de betydde nåkka.",
    "Marta sa ho ikkje ville blande sæ.",
    "Det va det sikreste tegnet på at saka allerede va kartlagt.",
    "Marta ba folk la saka ligge.",
    "Dermed fikk ho arbeidsro tel å finne ut resten.",
    "Søringen spurte om Marta va sjefen.",
    "Resten lo så stille de kunne.",
    "Marta satte mølja på bordet.",
    "Alle prinsipielle uenigheta fikk plutselig kortere setninga.",
    "Marta spurte om nån ville ha meir.",
    "Alle sa nei mens de strakte fram tallerkenen.",
    "Marta skar kaka i åtte bita.",
    "Det va ni sterke meninger rundt bordet.",
    "Marta satte fram feskekaka og kaffe uten å spørre.",
    "Det va den mest presise diagnosen i bua."
  ],
  "johannes": [
    "Johannes hørte motoren hoste én gang og sa ingenting.",
    "Fem minutter seinere sto Ronny med verktøykassa og et langt ansikt.",
    "Tåka kom siganes inn.",
    "Johannes såg på den som på en gammel kjenning han ikkje hadde savna.",
    "Johannes sa «jaja».",
    "Ronny brukte resten av dagen på å finne ut om det va ros eller advarsel.",
    "Johannes hørte på havet.",
    "Bamse hørte på Johannes, og det va ofte nok for resten av kaia.",
    "Nån skrøyt av motet sitt.",
    "Johannes venta tel stormen kom før han bestemte sæ for om han va enig.",
    "Johannes sa lite om det han savna.",
    "Men han lot alltid lyset stå på litt lenger enn nødvendig.",
    "Tåka kom, og Ronny foreslo meir fart.",
    "Johannes foreslo at vi skulle se kor vi va først.",
    "Johannes såg på himmelen, pekte én gang og gikk.",
    "Resten av oss brukte ti minutt på å skjønne at han hadde gitt en hel værmelding.",
    "En nybegynner gjorde feil.",
    "Johannes lot han prøv igjen, og det va nok tel at heile kaia skjønte at han hadde bestått.",
    "Johannes nikka én gang.",
    "Det kunne bety ja, nei eller at han hadde hørt nok.",
    "Nån kalla Johannes pessimist.",
    "Han svarte at pessimista sjelden blei overraska av dårlig fortøyning.",
    "Johannes nikka én gang og stilte opp før nån rakk å spørre.",
    "Det va sånn han sa ja.",
    "Johannes hørte motoren hoste én gang og sa at vedlikehold va billigere enn stolthet.",
    "Han hadde hørt dyrere lyda fra folk som venta for lenge.",
    "Johannes tok av sæ arbeidshansken og kjente på rekka.",
    "Han tok på sæ arbeidshansken igjen før han svarte.",
    "Johannes såg utover fjorden før han helsa.",
    "Det va den vanlige rekkefølga.",
    "Johannes lytta tel stillheta.",
    "Ho sa meir enn radioen.",
    "Johannes kjente lukta av tang.",
    "Det minna han om tusen morgena.",
    "Johannes tok et steg ut.",
    "Lufta va kald nok tel å vekke tankan.",
    "Johannes lot lua bli ligganes på bordet.",
    "Det va varmere enn det såg ut.",
    "Johannes lyfta koppen mot Ronny.",
    "Det va skål nok.",
    "Johannes hørte regnet start på taket.",
    "Han flytta sæ ikkje.",
    "Johannes la tauet i fine kveila.",
    "Han meinte rot smitta.",
    "Johannes løfta blikket mot fjellet.",
    "Skyan hadde flytta sæ i natt.",
    "Johannes strauk hånda over rekka.",
    "Ho va glatt etter regnet.",
    "Johannes såg tidevatnet snu.",
    "Han trengte ingen klokke.",
    "Johannes sto ei stund uten å si nåkka.",
    "Ingen venta på ord.",
    "Johannes smilte da postbåten la tel.",
    "Han hadde sett samme båt komme med ulike problemer i førti år.",
    "Johannes visste kor planken knirka.",
    "Han tråkka der likevel.",
    "Johannes lot vinden bestemme tempoet.",
    "Det va derfor han alltid kom fram etter folk med hastverk.",
    "Johannes så en niserygg ute på fjorden.",
    "Han sa ingenting før den viste sæ igjen.",
    "Johannes retta på ei bøye som hadde drevet skeivt.",
    "Det va lættere å rette på bøya enn på dem som hadde satt ho ut.",
    "Johannes nikka tel en båt som passerte.",
    "Helsinga blei besvart.",
    "Johannes dro båten litt lenger opp.",
    "Han visste kor høyt floa kom.",
    "Johannes hørte regnet gi sæ før nån andre merka det.",
    "Han hadde hørt uværet pakk sammen før resten så opp.",
    "Johannes bretta sammen et gammelt kart.",
    "Fjorden satt bedre i minnet.",
    "Johannes plukka opp et tau ingen visste kem som eide.",
    "Han la det på plass. Eier dukka alltid opp når nåkka bli rydda.",
    "Johannes tok med sæ den tomme koppen inn uten å bli bedt om det.",
    "Han va oppdratt før folk begynte å kall det initiativ.",
    "Johannes så etter skarven på skjæret.",
    "Han satt der som vanlig.",
    "Johannes la hånda på båtripa.",
    "Treverket va varmt etter sola.",
    "Johannes hørte ærfuglen pipe ute i vika.",
    "Han smilte for sæ sjøl.",
    "Johannes så en sel dukk opp mellom dønningan.",
    "Den fikk være i fred.",
    "Johannes løfta fortøyninga litt høyere.",
    "Han stolte ikkje helt på været.",
    "Bamse la snuten på støvelen tel Johannes.",
    "Johannes lot foten stå. Det va enklest.",
    "Johannes la lua på kroken.",
    "Da va han ferdig ute for dagen.",
    "Johannes gikk siste runden rundt båten før han gikk heim.",
    "Båten hadde ingen innvendinga.",
    "Johannes såg spor etter oteren i sanda.",
    "Han smilte og gikk videre.",
    "Johannes la et nytt vedtre i ovnen.",
    "Flammene tok godt imot det.",
    "Johannes stramma fortøyningene før natta kom.",
    "Han stolte meir på tauet enn på dem som hadde knytt det.",
    "Johannes så etter den gamle sjarken.",
    "Han kom som vanlig rundt odden.",
    "Johannes løfta blikket da en havørn sirkla over fjorden.",
    "Den hadde bedre oversikt enn folk flest på bakken.",
    "Johannes hørte kirkeklokkan langt borte over fjorden.",
    "Han sa ingenting. Det va kirkeklokken som hadde ærendet.",
    "Bamse la hodet i fanget tel Johannes uten et pip.",
    "Begge hadde sett nok for den dagen.",
    "Før frostrøyken slapp taket, sto Johannes allerede på brygga og såg utover.",
    "Det va lættere å se været før folk begynte å forklar det.",
    "Johannes dro garnet rolig inn.",
    "Han stolte meir på hendern enn på praten.",
    "Johannes pekte på ei mørk stripe i sjøen.",
    "Der sto seien.",
    "Johannes såg en stim småfisk heilt inne ved brygga.",
    "Han sa ingenting. Måsan hadde også sett dem.",
    "Johannes dro båten ut akkurat da floa snudde.",
    "Han hadde tydeligvis en avtale med floa.",
    "Johannes såg sola henge over fjellet lenge etter middag.",
    "Han hadde sett lyset gjøre det før. Det hadde bærre bedre tid enn folk.",
    "Johannes lukta regnet før skyan nådde fjorden.",
    "Det e derfor æ fortsatt ser på himmelen før æ ser på telefonen.",
    "Johannes kasta et blikk mot fjorden.",
    "Han fant alltid nåkka å følg med på."
  ],
  "faren": [
    "Faren kom sjelden tomhendt.",
    "Det va ved under armen, mat i posen og et besøk som va akkurat kort nok tel at ingen rakk å føl sæ tel bry.",
    "Faren hadde vanskelig for å be om unnskyldning.",
    "I stedet kom han tilbake med verktøy, ved og hender som allerede va i gang.",
    "For Faren va et løfte ei fortøyning.",
    "Du kunne ikkje bærre slæpp det fordi været blei dårlig.",
    "Når telefonen kom midt på natta, spurte Faren aldri om det va alvorlig.",
    "Han spurte kor han skulle kjøre.",
    "Familien kunne rop sæ tom.",
    "Faren venta tel alle va ferdige med å være sinte, og begynte så å rydda kjøkkenet.",
    "Faren reparerte det han kunne med hendern.",
    "Resten lot han stå litt i fred tel skammen hadde lagt sæ.",
    "Faren hadde alltid ekstra tau i kassa på pickupen.",
    "Han stolte ikkje på værmeldinga, og enda mindre på Ronny.",
    "Han sa ikkje at han va stolt.",
    "Marta såg det i måten han lot som han hadde et ærend forbi.",
    "Familien kunne bruk en time på koffer.",
    "Faren brukte ti sekund på kor.",
    "Han sto ofte litt på sida når alle va samla.",
    "Marta la merke tel at han smilte mest når ingen trengte han.",
    "Kom du seint heim, sto Faren ute tel han såg lys i vinduet.",
    "Først da gikk han inn og lot som han hadde lufta hunden.",
    "Faren va best med hendern.",
    "Han kunne reparere ei dør, en motor og av og tel en dårlig samvittighet.",
    "Når nån kom seint, fulgte Faren dem siste stykket.",
    "Han sa det va fordi veien over skaret va glatt, sjøl midt i juli.",
    "Familien krangla så bestikket dirra.",
    "Faren kom med ved og mat, som om begge deler va gyldige argument.",
    "Han gjorde det godt igjen med hendern.",
    "Ord meinte Faren va best tel instruksjoner og værmeldinga, og bærre den ene av dem stolte han på.",
    "Faren tok den tyngste kassa og den dårligste samvittigheta.",
    "Begge deler bar han uten å klag, men bærre den ene satte han fra sæ."
  ],
  "bamse": [
    "Bamse la sæ ved døra før nån visste kem som kom.",
    "Han hadde lært at uro ofte varsla selskap.",
    "Vinden snudde.",
    "Ronny fortsatte planen, og Bamse flytta sæ tel lesida.",
    "Johannes lot som han ikkje mata Bamse.",
    "Hunden lot som han sov heilt tel osten traff skjærefjøla.",
    "Folk krangla høyt.",
    "Ronny sa det va sunt å få ting ut, mens Bamse gikk ut sjøl.",
    "Vinden snudde.",
    "Bamse gikk ut, kjente etter og kom rett inn igjen med en tydelig vurdering.",
    "Bamse fant den varme flekken ved omnen før alle andre.",
    "De andre brukte resten av morgenen på å diskutere kor den va.",
    "Bamse sov videre mens verden ordna opp sjøl.",
    "Det va første gangen den dagen nån valgte riktig metode.",
    "Bamse la sæ under bordet.",
    "Derfra hadde han full oversikt.",
    "Bamse hørte en bil langt borte.",
    "Øyrene gjorde resten av jobben.",
    "Bamse snudde sæ mot sola.",
    "Han hadde valgt side.",
    "Bamse sukka og strekte på sæ.",
    "Formiddagskvilen va over.",
    "Bamse så etter katten borti veien.",
    "Han så den før alle andre.",
    "Bamse rulla sæ sammen.",
    "Dagen kunne godt vent litt.",
    "Bamse hørte motoren lenge før båten kom tel syne.",
    "Øyrene spissa sæ, og han stilte sæ ytterst på kaia.",
    "Bamse sukka fornøyd da ovnen blei tent.",
    "Han hadde ingen planer om å konkurrere med varmen.",
    "Bamse helste på alle som kom inn.",
    "Han va høfligere enn folk som hadde fått kaffe.",
    "Bamse sov gjennom heile regnbyga.",
    "Han våkna først da kjøkkendøra gikk.",
    "Bamse strakk sæ så lang han va.",
    "Så la han sæ ned igjen.",
    "Bamse la sæ framfor vedovnen før nån fikk fyr på den.",
    "Han flytta sæ ikkje før varmen kom.",
    "Bamse fulgte ei humle med blikket tel han sovna igjen.",
    "Humla flaug videre uten publikum.",
    "Bamse vakna bærre for å snu sæ tel den varme sida.",
    "Han venta på lyden som faktisk betydde mat.",
    "Bamse logra søvnig da døra gikk opp.",
    "Nesa va våken før resten.",
    "Bamse fant sæ en ny kvileplass i sola.",
    "Fem minutt seinere sov han.",
    "Bamse blunka mot lyset fra døropninga.",
    "Halen reagerte før resten av kroppen gjorde det.",
    "Bamse sov så tungt at han ikkje hørte måsan.",
    "Han våkna da matskåla traff gulvet.",
    "Bamse reiste sæ, strakk sæ og va klar for ingenting.",
    "Det va tydeligvis planen.",
    "Bamse krølla sæ sammen på matta.",
    "Kaia kunne pass sæ sjøl ei stund.",
    "Bamse logra stille da han hørte navnet sitt.",
    "Han trengte ikkje meir beskjed enn det.",
    "Bamse snudde sæ mot døra.",
    "Han kjente igjen stegan.",
    "Bamse hørte dieselmotoren før nån såg bilen.",
    "Han va allerede ved døra før motoren blei slått av.",
    "Bamse sovna før døra rakk å lukke sæ.",
    "Det va meir enn resten i bua klarte.",
    "Bamse såg på måsan, men visste at de ikkje va verdt bryet.",
    "Han hadde sett kor mye bråk en liten feskebit kunne lag.",
    "Bamse fant favorittplassen sin mellom vedsekken og døra.",
    "Der fikk han med sæ både varmen og utsikten.",
    "Bamse la sæ i døråpninga.",
    "Ingen protesterte.",
    "Bamse hørte ei bildør smelle og gikk rolig mot kaia.",
    "Han hadde hørt kem det va lenge før vi gjorde det.",
    "Bamse rista av sæ nån regndråpa og va ferdig med det.",
    "Resten av dagen trengte ikkje meir behandling.",
    "Bamse satte spor i nysnøen og såg fornøyd ut med resultatet.",
    "Han tok ruta som et personlig verk.",
    "Bamse rista snø av halen og gikk inn som om ingenting hadde skjedd.",
    "Snøen tok det meir personlig enn han gjorde.",
    "Bamse fant den varmeste plassen foran ovnen uten å leit.",
    "Han hadde aldri kasta bort tid på mellomtemperatura.",
    "Bamse reagerte på vedkløyveren lenge før vi andre hørte den.",
    "Han hadde bedre varslingsanlegg enn kommunen.",
    "Bamse sov sæ gjennom heile snøbyga.",
    "Han venta på lyden som faktisk betydde mat.",
    "Bamse snuste på den våte jorda og logra.",
    "Våren va godkjent.",
    "Bamse fulgte lukta av fisk heilt bort tel sløyebenken.",
    "Han hadde aldri trengt skilt.",
    "Bamse satt heilt stille mens en sommerfugl landa på trappa.",
    "Det va tydeligvis verdt å være våken for.",
    "Bamse sov med ett øre på vakt.",
    "Det andre hadde fri.",
    "Bamse fant en pinne som va for lang for døråpninga.",
    "Han prøvde tre ganger før døra fikk skylda.",
    "Bamse la sæ midt på brygga.",
    "Kvelden fikk gå rundt.",
    "Bamse strakte sæ i sola før han fant den beste kvileplassen.",
    "Han fant plassen før sola rakk å flytt sæ."
  ],
  "havet": [
    "Bølgan går høyt, men havet har bedre tid enn folk.",
    "Sjøen e klar tel neste forsøk før folk e det.",
    "Den som ser lenge nok utover havet, finn sjelden svaret han håpa på.",
    "Bærre det spørsmålet han burde ha stilt.",
    "Havet har aldri ledd av nån som prøvde.",
    "Men fortøyninga røper raskt kem som faktisk gjorde jobben.",
    "Havet bli stille.",
    "Da løfter floa ofte gamle ting opp igjen, enten folk e klar eller ikkje.",
    "Havet tar ikkje parti.",
    "Det bryr sæ bærre om du har gjort jobben godt nok.",
    "Havet lær tålmodighet uten å forklar pensum.",
    "Det gir bærre beskjed tel dem som faktisk hør etter.",
    "Havet husk alle som trudde de hadde kontroll.",
    "Der ute bli forskjellen på mot og dumskap tydelig fort.",
    "Det e lett å snakk stort på land.",
    "Ute bli det fort tydelig om ordan hadde regnklær.",
    "Floa kommer og løsner det folk trudde satt fast.",
    "Da bli gamle feil vanskeligere å skjul.",
    "Havet husk gamle feil bedre enn folk gjør.",
    "Floa løfter dem opp når det passer dårligst.",
    "Det e lett å snakk stort på land.",
    "Ute tell bærre det du faktisk gjør når båten begynn å drive.",
    "Havet har aldri ledd av nån som prøvde.",
    "Men det skåner heller ingen for konsekvensan av en dårlig jobb.",
    "Det finnes svar sjøen ikkje gir.",
    "Da står bærre spørsmålet igjen: gjorde du jobben?",
    "Havet bli stille.",
    "Det betyr ikkje at jobben e gjort, bærre at du får hør bedre.",
    "Floa kommer og viser ka som va godt nok festa.",
    "Resten får ingen forklaring.",
    "Floa kommer.",
    "Fortøyninga forteller resten uten å heve stemmen.",
    "Havet lær tålmodighet uten å forklar pensum.",
    "Jobben må du likevel gjøre sjøl.",
    "Vinden la sæ over fjorden.",
    "Da sto resultatet av jobben igjen, uten bortforklaringer.",
    "Floa kommer.",
    "Den spør ikkje om du har gjort jobben, den sjekker.",
    "Havet bar ei gammel bøye inn mot fjæra før frokost.",
    "Det e sånn sjøen gir beskjed uten å skrive nåkka.",
    "Havet gir ingen løfter.",
    "Når det stilner, hør man ka som fortsatt står.",
    "Skyan legg sæ lavt over kaia.",
    "Da hjelper det lite å være optimist uten oljehyre."
  ],
  "kaia": [
    "Kaia husk tida da nyhetene kom inn sammen med første båten og lukta av salt.",
    "Sladderen kom i samme bølge, men blei som regel ligganes lengre på land.",
    "Kaia husk kvelden lyset kom tassanes over brygga som en ny katt.",
    "Ingen stolte heilt på det før kaffekjelen fant bryteren og slo av mørket.",
    "Kaia husk morgnan da lever, diesel og kaffe blanda sæ tel et alibi for å stå opp.",
    "Når den lukta kom, visste alle ka retninga va.",
    "På kaia sto folk langs moloen i mørket med hetta oppe og kaffekopp i lomma, ventanes på lyset fra leia.",
    "Nån venta på grønnblinket, andre på et tegn om å snu heim.",
    "Ronny klappa rekka og sa det kom tel å gå bra, som han alltid gjør.",
    "Overraskanes ofte gjorde det det, mest fordi alle andre dobbelsjekka alt han hadde hoppa over.",
    "Bamse la sæ ved støvlan tel den som bar stillheta tyngst, og pustan blei rolig rundt han.",
    "Han tok sjelden feil, og ingen spurte koffer han visste.",
    "Da første TV-en dukka opp, sto halvbygda og speila sæ i rutan før sending.",
    "Inne va det stappfullt, og lyden fra Oslo gjorde kaffekjelen stille.",
    "Før kunne du hør forskjell på kvær eneste motor langt ute i sundet.",
    "Når én lyd mangla ved morgenskaffen, visste alle kem vi venta på.",
    "På rekkan ligg lag av navn, nye malt over gamle med tung pensel.",
    "Malinga bære meir minne enn ho klar å skjul, akkurat som folk.",
    "Det va tider der brødskivan flaug like ofte som kjeften mot måsan.",
    "De spiste sæ modig den gangen òg, og blei ikkje det spor høfligere.",
    "I bodene på kaia fantes det alltid en hammer på vei tel naboen og et målebånd i eksil.",
    "Vi husk verktøyet som forsvant, og historia som fulgte med unnskyldninga.",
    "Den dagen sola kom tilbake etter mørketida, blei kaia lys igjen og folk løfta haka som om nån ropte opprop.",
    "Tel og med Johannes dro litt på smilebåndet, og det telle som jubel hær.",
    "På sankthans tok bålet alltid litt meir enn planlagt.",
    "Johannes sa ikkje mye, men han va allerede på tur etter bøtta før flammen fikk nye påfunn.",
    "Æ husk når ferga skaut lysan inn i mørket og speilet fjellan.",
    "Før ho la tel, hadde Bamse allerede varsla kem som kom heim.",
    "Første mobilen kom ned på kaia som en sjelden sei, og blinka usikkert.",
    "Ronny meinte dekninga lå i baugen, og holdt apparatet mot sjarken for sikkerhets skyld.",
    "Æ husk første gangen far lot mæ vri om på den gamle motoren, dieselosen varm som kaffe i maskinrommet.",
    "Lyden va større enn mæ, men hånda hans va nær nok tel å dempe alt.",
    "Æ husk mørketida før utelysan kom opp, når snøen knitra og sjøen pusta svart langs kaia.",
    "Vi kjente folk på stegan, og Bamse kunne navnan med halen.",
    "På kaia visste alle kem som eide kvær sykkel, saltstøvet fungerte som initiala.",
    "Låsan hang heime på spikeren; det va naboens blikk som va nøkkelen.",
    "Brødan kom i trekassa før frosten slapp rekka.",
    "Måsan hadde lært ruta like fort som oss, så vi sprang før vi rakk å si bordbønn.",
    "Æ husk da værmeldinga kom én gang om dagen på skurranes radio, og alle blei stille som i kirka.",
    "Resten av døgnet leste Marta himmelen, mens Johannes leste lyden i moloen.",
    "Æ husk vinteren sjøen fraus innerst i bukta så isen sang.",
    "Bamse tok to stolte steg utpå, sklei som en hyse på dekk, og kom tilbake med blikket som sa at is e juks.",
    "Æ husk da fiskekassan va av tre, grå og fuktig som november.",
    "De va så tunge tom at ryggen lærte respekt før fangsten gjorde det.",
    "Æ husk lyden av sjøvåte støvla i gangen etter uvær.",
    "Det va bygdas fineste orkester, og først da slutta hjertet og Bamse å stå i beredskap.",
    "Æ husk da nøkkeln lå under matta hos alle.",
    "Skulle nån stjæl, måtte det være en som ikkje visste at døra uansett sto åpen.",
    "Ronny kom ned med glis og sa han hadde en plan for heile dagen.",
    "Marta tok fram plaster og kost, for hos oss følges idean som regel av etterarbeid.",
    "Johannes såg på målestokken og spurte tørt om han hadde målt.",
    "Ronny sa han hadde sett på det, så Johannes målte for begge og lot stillheta forklar forskjellen.",
    "Ronny slo fast at han hadde full kontroll på både vær og verktøy.",
    "Bamse rista på pelsen, gikk ut og la sæ i le, som en vennlig fotnote fra virkeligheta.",
    "På kaia kom Marta med matboksen og spurte om Ronny hadde spist.",
    "Han svarte at han hadde tenkt på det, og ho dytta brødskiva i hånda hans før tankan blei kalde.",
    "Ronny heva stemmen med et 'Hør nu hær' som lova lang omvei.",
    "Bamse sukka tungt, la hodet på potan og venta tålmodig på poenget som sjelden kom først.",
    "Ronny kom inn dryppanes som en sjark uten lensepumpe.",
    "Marta minte han på at han hadde sagt det ikkje regna; Ronny heva skuldran og meinte været hadde mista respekten for han.",
    "Regnet dreiv over kaia da Marta stoppa Ronny ved rekka og sa at nu måtte han hør etter.",
    "Ronny smilte og meinte han hør best etterpå, når skaden va gjort og historia kunne pyntes litt.",
    "Johannes sto tørr under kalesjen og spurte kem som hadde festa fenderen så løst.",
    "Ronny studerte skyan som om de kunne innrømme det for han, og Bamse sukka kort.",
    "Johannes rista på hodet ved benken og sa at da bli maten kald om vi står og prata meir.",
    "Marta nikka og sa ho veit, men at nån må berges fra egne ideer først.",
    "Ronny hevda han bærre hadde lånt stolen fra benken ved bua.",
    "Marta peka på verandaen hans og sa at lån normalt ikkje inkludere å bære tingen heim.",
    "Johannes såg ut mot moloåpninga og sa at vi venta.",
    "Ronny spurte ka det va, og havet svarte med å hold pusten litt lenger.",
    "Ronny stilte sæ midt på kaia og erklærte at han kunne forklar absolutt alt som hadde skjedd i går.",
    "Marta pekte på arbeidet og sa det va bedre med ferdig enn forklart.",
    "Skyan la sæ tjukkere over fjelltoppan, og Johannes slo fast at været tok tel.",
    "Ronny smilte og hevda humøret va stabilt, men sjøen brydde sæ som vanlig ikkje om stemninga hans.",
    "Johannes pakka sammen med den roen som betyr at dagen e over, og sa vi skulle heim.",
    "Ronny protesterte at han va akkurat i gang, men kaia hadde allerede slått av lyset.",
    "Ronny flira og sa at flertallet hadde talt, og det va greit så lenge det va hans idé.",
    "Johannes nikka kort: endelig, og lot motorlyden erklære møtet over.",
    "Plankan knirka akkurat der de alltid har gjort når du går ut på morran.",
    "Det e kaia sin måte å spørre om du virkelig har fortøyd, eller bærre håp på det.",
    "Døra tel bua står åpen sjøl i ruskevær, og hengslan klaga som gammelt mannskap.",
    "Ingen skriv sæ opp på nåkka; kaia husk kem som lånte hammeren sist.",
    "Kaia har hørt fleire løfta blåse bort i sørvesten enn ho gidde å telle.",
    "Ho e enklere enn folk; ho vil bærre se at du har fortøyd skikkelig.",
    "Når det siste båtlyset runde moloen, bli kaia stille og lufta salt.",
    "Folk finn alltid ei unnskyldning for å bli litt tel, som om lyset kunne snu.",
    "Når måsan endelig tie, kjennes kvelden som om han hold pusten.",
    "Den lengste vakta har sjelden klokke, bærre øya som lete etter lys ute i mørket.",
    "Den gamle benken står fortsatt skeiv, som om han husk kvær storm som har vært innom.",
    "De lengste samtalan har aldri klokke, bærre termoslukt og sjøsprøyt.",
    "Kaia tar imot den som kjæm tilbake med nye unnskyldninga og gamle støvla.",
    "Benken spør ingenting, og likevel svar folk når de endelig sett sæ ned.",
    "Kaia har hørt fleire løfter enn ho orka å tell, både i ruskevær og midnattssol.",
    "Treverket glømma mindre enn folk; det knirka når historia ikkje stemma.",
    "Når måsan tie et øyeblikk, kjennes kaia tom som en søndagskveld.",
    "Så kjæm nån trilanes med barnevogn og kaffe, og stillheta finn sæ en ny lyd.",
    "Kaia sei ikkje nåkka når nån kjæm heim igjen etter år borte.",
    "Latteren finn veien før ordan, og Bamse vifte som om det va i går.",
    "Kaia veit kem som alltid går sist når uværet løye, han som sjekke tauverket en gang tel.",
    "De som holdt i lag, trengte sjelden meir enn et nikk før kursen heim.",
    "På kaia skin ny maling, men under ligg navnan som va hær før.",
    "Båtan bli pussa opp kvær vår; det e mest vi som lat som vi e nye.",
    "Når motorlyden endelig legg sæ, bli måsan for en gang skyld stille.",
    "Da synka skuldrene hos dem som har venta, og kaffen smaka som nåkka de har fortjent.",
    "Plankan bære fortsatt merker etter støvlan som ikkje går hær meir.",
    "Likevel finn latteren fram kvær gang nån mimre, som om han hadde egen nøkkel.",
    "Plankan knirka på samme flekken som alltid når første stegan treffa morgenkaia.",
    "Lyden spør ikkje kem du e, den bærre svar: du e heim igjen.",
    "Kaia legg merke tel kem som alltid bli igjen når alt anna e ferdig lasta.",
    "Som regel e det han som tel tau og folk, og glømme sæ sjøl tel slutt.",
    "En måse gikk bortover brygga som om ho eide plankan.",
    "Ingen sa nåkka. Ho hadde allerede fått viljen sin.",
    "Gamlekaffen sto fortsatt på kanna.",
    "Ingen syntes det va et problem.",
    "En måse prøvde lykken ved sløyebenken.",
    "Den va ikkje den første.",
    "Vinden tok en runde rundt naustet.",
    "Døra svarte med et knirk.",
    "Posten kom seint.",
    "Ingen på kaia lot sæ stresse av det.",
    "Ei bøye dansa sakte i dønningan.",
    "Ho hadde god rytmesans.",
    "En måse fløy lavt over brygga.",
    "Ingen fisk slapp unna.",
    "Fjorden lå åpen heilt mot nord.",
    "Det så ut som den aldri tok slutt.",
    "Kaffelukta fant veien heilt ut tel brygga.",
    "Det va den eneste beskjeden som fikk alle inn samtidig.",
    "Ei sky dro sakte over sola.",
    "Temperaturen tok hintet.",
    "Kaia fikk besøk av en turist.",
    "Måsan tok imot først.",
    "Fjorden pusta tungt mot moloen.",
    "Lyden hørte heime der.",
    "En gammel fender knirka mot brygga.",
    "Ingen hadde hørt en bedre melodi den morran.",
    "Kaffekoppen sto igjen på benken.",
    "Eieren va aldri langt unna.",
    "Sola fant et hull mellom skyan og traff naustveggen.",
    "Resten av bygda brukte dagen på å finne mørket igjen.",
    "En måse stjal fiskeslo og forsvant uten å takke.",
    "Kaia hadde andre ting å bruk høflighet på.",
    "Fjorden lå blank som glass før vinden våkna.",
    "Alle rakk å tru på stillheta før ho forsvant.",
    "Ei terne skar gjennom lufta som om ho eide himmelen.",
    "Ingen på kaia protesterte. Ho hadde bedre oversikt enn dem.",
    "Kaffikjelen begynte å synge på komfyren.",
    "Det va det eneste i bua som visste når folk burde holde kjeft.",
    "En gammel garnblåse lå fortsatt på samme plass.",
    "Ingen flytta den. De hadde allerede nok som dreiv.",
    "Kaia våkna sakte.",
    "Ho hadde aldri hatt hastverk.",
    "Morgendisen lå som et tynt teppe over fjorden.",
    "Kaia våkna litt etter litt.",
    "En fiskebåt la sakte fra kai.",
    "Tauverket fikk siste ord.",
    "Regnet tromma mjukt mot nausttaket.",
    "Ingen hadde nåkka imot lyden.",
    "En måse landa elegant.",
    "Så begynte ho å skrike og ødela heile inntrykket.",
    "En gammel trebåt lå stille ved brygga.",
    "Han såg ut tel å trives der.",
    "Et lite vindkast fikk naustdøra tel å sukke.",
    "Det va omtrent det mest dramatiske som skjedde.",
    "En lett morgenbris flytta på flagget.",
    "Resten av kaia tok det med ro.",
    "Ei rekke med skarv flaug lavt over fjorden.",
    "Ingen av dem hadde det travelt.",
    "Kveldslyset gjorde naustveggen gyllen.",
    "Det va nok pynt for den dagen.",
    "Ei sky åpna sæ i et lite minutt.",
    "Sola nytta sjansen.",
    "En fisk hoppa heilt inne ved brygga.",
    "Ringene levde lenger enn plasket.",
    "Ferga kom fem minutt for seint.",
    "Ingen såg ut tel å merk det.",
    "Ei sky la fjellet i skygge.",
    "Fjorden fortsatte å glitre.",
    "En småbåt tøffa sakte forbi.",
    "Bølgan kom lenge etterpå.",
    "Morgensola nådde brygga før folk gjorde det.",
    "Det va første gangen dagen kom presis.",
    "Ei rekke ender kryssa vågen i perfekt orden.",
    "Ingen på kaia klarte det samme før første kaffe.",
    "Nordlyset dansa over fjorden.",
    "Ingen hadde hastverk med å gå inn.",
    "Kaffekoppen va varm lenge etter at praten stilna.",
    "Det va samtalen som hadde blitt kald først.",
    "Fjorden lå blank og kald.",
    "Kaia va klar for en ny dag.",
    "Den første båten gikk ut før sola va oppe.",
    "Motorlyden lå igjen mellom husan.",
    "Ei havørn kom lavt over fjorden.",
    "Alle såg opp samtidig.",
    "Fjorden skifta farge kvær gang skyan flytta på sæ.",
    "Ingen av fargan holdt lenge nok tel å bli enige om navnet.",
    "En varm vind dro lukta av nyslått gress ned tel kaia.",
    "Det va den eneste dagen kaia lukta som innlandet.",
    "Morgenen kom stille over kaia.",
    "Bærre sjøen va allerede våken."
  ],
  "personal": [
    "Uro kan være kjærlighet uten plass å gjøre av sæ.",
    "Og det kan være advarsel; kunsten e å vite kem som snakka før du handla.",
    "Det du prøv å gå rundt, venta som regel i svingen.",
    "Kvær gang du snik dæ forbi, står det tydeligere i veien neste runde."
  ],
  "winter": [
    "Før soloppgang knirka snøen så høyt at det kjennes tomt mellom husan.",
    "Når frosten stramma alt, kjæm lydan nærmere, som om bygda pusta inn samtidig.",
    "Vinteren kom inn fra havet med rim på rekkan.",
    "Johannes fant fram ullskjerfet uten å sei nåkka, og alle forstod at dette blei en dag for korte svar.",
    "Kulda fant først sprekkene i døran og de gamle knutan, og beit sæ fast i nevvan.",
    "Fortøyningan svara med lav knirking, som om båtan ba pent om å bli holdt litt hardere.",
    "Vinteren gjør små varme ting større enn de va tenkt.",
    "En kopp fra Marta eller et nikk fra Johannes kan bær en heil dag, mens havet pusta kvitt rundt oss.",
    "Kulda fant sprekkene før vi gjorde det.",
    "Marta hadde allerede mata ovnen med meir ved og hengt votta nærmest varmen, som en plan B.",
    "Vinteren rulla inn fra havet så tauverket sang i pullertan.",
    "Fortøyningan svarte med knirk mens knutan stramma sæ, som om båtan òg gjorde sæ klar for mørket.",
    "Støvlan sto fast i gangen, så kalde at de klang.",
    "Marta hadde allerede mata ovnen og pekt på tørrsokkan, uten å bruk et ekstra ord.",
    "Snøen la sæ tjukk over kaia og benkan forsvant i kvitt.",
    "Ronny kalte det uteservering og satte kaffekoppen i en snøskavl som om det va bord.",
    "Snøen knirka før soloppgang og pusten sto som røyk over kaia.",
    "Johannes fant fram ullskjerfet og nikka, som om kulda va en gammel kollega.",
    "Det knirka i snøen før soloppgang, så stille at pusten laga skyer.",
    "Bamse gikk med forsiktige labba, som om han va redd for å forstyrre natta.",
    "Frostrøyken står over kaffekoppen som et lite bål du kan drikk.",
    "Marta hadde allerede lagt meir ved i ovnen, så praten tinte før fingran gjorde det.",
    "Snøen legg sæ over kaia som et ullteppe som ber oss tie litt.",
    "Ingen late som det e sommer; vi late bærre som vi ikkje fryse.",
    "Snøen legg sæ over kaia og dempe alt unntatt fottrinnan.",
    "Ho veit kem som kjæm; Johannes trør jevnt, Ronny slure, og Bamse går midt i sporet.",
    "Støvlan sto fast i gangen etter natta, så vi måtte vri dem laus før skiftet.",
    "Ronny hevda det fortsatt telle som uteservering når vi drikk kaffen i full vinterpust.",
    "Kulda fant alle sprekkan i bua før vi gjorde det, og vinden sang gjennom veggan.",
    "Johannes sa lite, bærre treiv ullskjerfet og stramma det som ei pakning.",
    "Snøen knirkte før soloppgang og nesa beit tilbake kvær gang vi pusta.",
    "Ronny erklærte sesong for uteservering og ba oss nyte sprøtt underlag og lunka kaffe.",
    "Vinteren rulla inn fra havet som kald damp over bryggekanten.",
    "Marta hadde lagt meir ved lenge før vinden slo i døra; ho ligg alltid ett hakk foran kulda.",
    "Støvlan frøs fast i gangen, og dørmatta blei tel skøyteis.",
    "Bamse gikk på tå hev som om han hadde gjort det sjøl.",
    "Frostrøyken sto tung over kaffekoppen på benken i nordavinden.",
    "På sånne morgena e en varm kopp ikkje luksus, det e dugnad for henda og humøret.",
    "Isen la sæ blank innerst i bukta og dempa all lyd.",
    "Johannes fant fram ullskjerfet uten kommentar; når han kle på sæ, treng ingen diskutere temperaturen."
  ],
  "spring": [
    "Etter vinteren sto båtan klar, tau og verktøy fant plass igjen.",
    "Johannes nikka og sa at kalenderen endelig hadde fått rett; våren trengte visst godkjenning fra han.",
    "Den første tjelden landa svart og kvit nedom slipen og skreik som vanlig.",
    "Da rulla året sakte over på vår, og kaia trakk pusten litt friere.",
    "Sola traff naustveggen igjen, og treverket kvitta sæ med vinterfargen.",
    "Vi lot døra stå åpen så naustet kunne hør måsan, dryppet og alt det nye som skulle inn.",
    "Det lukta våt jord og gammelt tau bortmed naustet, og småpyttan va tilbake i hjulsporan.",
    "Alle andre flytta støvlan nærmere døra; erfaringen veit ka værmeldinga gløm.",
    "Marta åpna vinduan mot kaia, slapp inn luft som lukta rått tau og smelta snø.",
    "Vi nikka høflig tel våren, men lot ullgenseren bli på.",
    "Våren starta med drypp fra taket og en hes måse som prøvde ny stemme.",
    "Når isen slepp, dukka både søppel og håp opp langs kaikanten.",
    "Marta åpna vinduan og banka fillerya utover kaia så støve sto.",
    "Vinteren fikk se rotet ho etterlot, og vi lot den skjemmes i trekken.",
    "Ronny kom trampan med malingsspann og overmot og erklærte vårrengjøring på rekka.",
    "Resten av oss rygga mot kaifronten, for med han bak kosten spruta malinga som fra ei pumpe.",
    "Snøen slapp taket i sørveggen og datt i tunge, våte sukk.",
    "Johannes såg opp fra verktøykassa og nikka, som om kalenderen endelig hadde bestått prøven.",
    "Kaia våkna sakte, båtan skull ut etter vinteren og lukta av tjære kom tilbake.",
    "Folk blei ståanes litt lenger ute, som om lyset trengte tid for å finne dem.",
    "Båtan skull ut, skreien va nesten ferdig, og iskantan holdt avstand.",
    "Ingen stolte heilt på våren ennå; vi lot han vis sæ i ei uke først.",
    "Det dryppa jevnt fra takskjegget, våren sa hallo uten å love nåkka.",
    "Ingen stolte heilt på han ennå; vi hengte likevel votta tel tørk for sikkerhets skyld.",
    "Båtan skull ut etter vinteren, og skroga bar riper som rapport fra mørketida.",
    "Vi fikk se ka kulda hadde gjort, og kosta det vekk med varm kaffe og bannskap.",
    "Marta åpna vinduan på bua så kaffelukta rømte ut på kaia.",
    "Folk blei ståanes litt lenger ute, som om koppen smakte bedre når lyset traff fjeset.",
    "Snøen slapp taket i brune flekka langs grøftekanten og rundt pullertan.",
    "Det dukka opp både søppel og håp, og vi plukka litt av begge før lunsj.",
    "Den første tjelden skreik sæ ned på steinan i morges.",
    "Vi nikka høflig, men lot fortsatt skrapa på isen ligge framme, for våren e kjent for å angre sæ.",
    "Sola traff naustveggen så flassan i malinga glitra som skjell.",
    "Under lyset dukka både vinterens søppel og nye plana fram, og vi måtte ta tak i begge deler.",
    "Sola slo inn på naustveggen og avslørte kvær sprekk vinteren hadde signert.",
    "Vi sto og leste regnskapet i stillhet, og bestemte oss for å betal med dugnad.",
    "Ronny stilte på kaia med malingsspann og et smil som lova for mye.",
    "Vi flytta båtan litt lenger unna og lot han begynne på pullerten først.",
    "Snøen slepp taket langs kaikanten, og smeltevannet finn igjen alle sporan i plankan.",
    "Vinteren legg fram rapporten sin i drypp og knak, og vi late som vi visste om kvær ripe fra før."
  ],
  "summer": [
    "Marta bar kaffekanna ut på benken, og lukta dro folk sammen som floa.",
    "De gamle historian fikk nye øra og nye versjona, akkurat passe søta med sukker og sjøluft.",
    "Sommern slo opp naustdøran på vidt gap, lukta av tjære og tang blanda sæ i sola.",
    "Sjøl Johannes nikka og sa det fikk duge, som e samme som jubel fra han.",
    "Treverket på kaia va solvarmt og ga fra sæ den gamle naustlukta.",
    "Johannes dro inn pusten, myste mot sjøen og medga at dagen kunne få bestå.",
    "Kaia fyltes av fremmede stemmer og latter som hoppa mellom rekkan.",
    "Plutselig va det både uhøflig og umulig å gå heim tidlig, så middagen måtte vent på bryggekanten.",
    "Ronny erklærte badesesongen åpna før floa rakk å snu, og spratt uti med et brøl.",
    "Resten av oss lærte et par nye bannord mens vi dro han opp og pakka han inn i alle hånddukan vi fant.",
    "Sommerregnet slo ned så brått at alt under åpen himmel blei tynnkaffe på to sekund.",
    "Bamse gikk motsatt vei, fant han som satt aleina på benken, og la hodet i fanget hans.",
    "Kveldslufta e fortsatt varm, sjøl etter at sola forsvant bak moloen.",
    "Johannes nikka og kalte det isfritt vann, som va hans måte å sei at vi hadde ingenting å klag på.",
    "Kaia lukta solvarmt treverk og tjære, og alle prata høyt som om juli trengte meir lyd.",
    "Bamse la sæ i skyggen ved støvlan tel han som satt aleina, og holdt han med selskap uten å spørre koffer.",
    "Det lukta solvarmt treverk og nypåsmurt olje, som om kaia sleit av vinteren.",
    "Utover dagen lærte ho nye navn, og alle blei litt meir fra hær mens sola sto på.",
    "Sommeren kom med åpne naustdøra og lukta av tjære og kaffe.",
    "Plutselig fikk både søringa, Johannes og måsan plass under samme tak uten at nån krangla.",
    "Kaia blei full av fremmede stemmer og lyden av isboksan.",
    "Sjøl Johannes nikka og sa dagen va fin, og æ måtte le litt av at han sa det høyt.",
    "Båtan lå tett i gjestehavna, tau krysse som naboer i kø.",
    "Johannes løfta øyebrynet og sa dagen va fin, og vi noterte det som offisiell værmelding.",
    "Det lukta solvarmt treverk og salt på innsida av naustet.",
    "Når døra sto åpen, fikk alle plass under samme tak, arbeid, skrøner og han som bærre trengte en stol.",
    "Kaia va full av fremmede stemma og fotoapparat som klikka i takt med måsan.",
    "Innen kvelden visste benken fleire navn enn mæ, men havet brydde sæ fortsatt mest om vær og flo.",
    "Sommerregnet kom brått så kaia samla sæ under tak og lånte bort tørre flekka.",
    "Når praten først tar fart i et slikt skur, bli det fryktelig vanskelig å gå heim tidlig.",
    "Kveldslufta va fortsatt varm, og regnet trua bærre for syns skyld.",
    "Under nausttaket fikk alle plass, tel og med Ronny sin optimisme og Johannes sitt behov for stillhet.",
    "Kveldslufta va fortsatt varm og måsan ga opp å mase.",
    "Folk blei sittanes så lenge at natta glømte å bli mørk, og Bamse snorka først for å markere stengetid.",
    "Sommerregnet kom som nån helte ei bøtte over bygda, og alle spratt inn under presenningen.",
    "Der e det rart kor lett det bli plass, både tel folk og lange historia.",
    "Båtan lå tett i gjestehavna så fendran sa hei på kvær bølge.",
    "Folk blei sittanes og bytta ord på kryss av språk, heilt tel natta glømte å bli mørk.",
    "Ronny erklærte badesesong så fort sola traff bryggekanten, og hoppa uti før nån rakk å advare.",
    "Etter det blei det umulig å gå heim tidlig, for alle måtte varme han opp."
  ],
  "autumn": [
    "Regnet la sæ ned og nekta å gå.",
    "Vi skrudde på lysan før middag, og kaia så ut som ho tok kveld to ganga om dagen.",
    "Ronny påsto det fortsatt va sommer og stilte i kortarma skjorte.",
    "Vi fant fram hodelyktene likevel; selvtillit gir lite dagslys.",
    "Lufta bet litt i morran, så kaffekoppen blei holdt med begge hender.",
    "Etter lunsj gikk alle en ekstra runde langs fortøyningan, som om ro kan knytes fast.",
    "Ronny forklarte høyt at august egentlig e juli med bedre rutine.",
    "Vi lot han prat mens vi tok en runde med knutan; været hør sjelden på foredrag.",
    "Høsten kom med skarpere luft over kaia og lyden av metall som trakk sæ.",
    "Alle visste ka som kom: kortere dag, strammere tau og meir alvor i blikkan.",
    "Johannes sto og studerte trekkfuglan som samla sæ i skakk V over moloen.",
    "Dem hadde holdt på heile natta, nikka han, som om han kjente skiftlista deres.",
    "Marta fant fram de tykke gardinan og stappa trekken ut av huset før han rakk å gjøre sæ heim.",
    "Sånn pakka året ilag hos oss: mørke først, varme like etter.",
    "Marta dro fram de tjukke gardinan og sa at kvelden kjæm fortere nu.",
    "På kaia begynte folk å sjekke tauan litt oftere, som om nordavinden allerede pusta.",
    "Johannes sto med hendern i lomman og såg trekkfuglan saml sæ over moloen.",
    "Han nikka sakte og sa at året hadde begynt å pakk i lag, og vi måtte det samme.",
    "Johannes peika mot himmelen der trekkfuglan samla sæ i stram V.",
    "Han sa at nu va det alvor, og dro lua nedover øran som punktum.",
    "Regnet va ikkje brått lenger; det bærre holdt på.",
    "Det hadde heile natta tel å finne glipan i klær og minner.",
    "Regnet la sæ seigt over kaia, som om det hadde planlagt alt.",
    "Alle visste ka som kom: mørkere morgna, tyngre tau og stillere prat.",
    "På kaia lå lukta av tang, våt ved og kaldt jern tung som fjære sjø.",
    "Ingen trengte værmelding; vi visste at det va høsten som gjorde kaia klar tel arbeid og stillhet.",
    "Båtan blei dratt opp på land én etter én mens skya hang lavt over fjellan.",
    "Johannes nikka bærre, ullhua trekt ned over øran; når han blei stille sånn, visste alle at sesongen va ferdig.",
    "Første løvskura piska over kaidekket, vått som nysløydd fisk, med salt og tang i lufta.",
    "Vinden hadde gjort overtida heile natta, og vi skjenka stærkere kaffe uten å sei nåkka.",
    "Johannes sto stille og såg trekkfuglan samle sæ over moloen, svarte prikker mot grå himmel.",
    "Han sa ingenting; vi visste at det va høsten sin tur, og at kaia snart skulle savne lyden.",
    "Regnet slutta å komme i kast og begynte å ligge seigt over molo og rekker.",
    "Da gikk folk rundan sine og sjekka knutan litt oftere; høsten minne dæ på ka som kan gli uten lyd.",
    "Båtan blei hala opp på land én etter én, med kjølen mot trestøttan mens høstkulda beit i hendern.",
    "Marta hengte opp ekstra lyspærer i bua; når mørket tar dagan, må vi hjelpe lyset litt.",
    "Regnet la sæ i lange drag over plankan, så sakte at timan glapp mellom fingran.",
    "Folk fant kvær si klype takskjegg, og mellom oss blei kaia større; stillheta va ikkje uvennlig, bærre våt.",
    "Høsten kom med skarpere luft og sjøl kaffen føltes varmere i hendern.",
    "Vi la tauverk og planer i penere kveil, som om året pakka sæ heimover samtidig som vi gjorde det."
  ],
  "morketid": [
    "Mørketida la sæ over bygda som et tungt teppe, og lyden av havet blei nærmere.",
    "Når dagan e korte, må du bruk både lyset og stillheta godt.",
    "Marta tente lykta tidlig og rista litt snø av trappa på kaia.",
    "Ronny dukka opp i refleksvest som om han va et fyr, og ho nikka fornøyd over at nån endelig hørte etter.",
    "I mørketida e natta på jobb sjøl ved lunsj, og kaffen smaka som om den veit det.",
    "Stemman kom først, ansikta dukka opp når nån huska hodelykta.",
    "Mørketida la sæ over bygda og vinden spela i den tomme kaibua.",
    "Bamse tok plassen nærmest ovnen med ryggen mot døra, som om han passa på varmen for oss andre.",
    "Dagslyset va bærre en kort gjest som kom og forsvant før kaffekjelen rakk å putre ferdig.",
    "Johannes nikka mot sør og sa rolig at ho e der, vi treng ikkje se ho kvær dag.",
    "Ronny påsto han likte mørket, for da slapp han å se rotet sitt.",
    "Vi samla oss rundt kaffekjelen uansett, for selskap e den eineste vedfyringa som alltid tar fyr.",
    "Ronny prata om kor trygt og fint mørket va, som om han eide natta.",
    "Samtidig glinsa refleksvesten så sterkt at måsan kunne navigere etter han.",
    "Mørketida la sæ tung over bygda så husan sto som skygga av sæ sjøl.",
    "En kar kom gåanes i refleksvest og lot som det va for vår del, ikkje hans.",
    "Når mørket pressa sæ inn tidlig, blei lysan i vinduan plutselig som fyrlykter hjemover.",
    "Inne rundt bordet skjønte vi at selskap e varmen som ikkje tar strøm.",
    "Marta tente lykta før mørket rakk å komme heilt, så ingen skulle snuble på kaia.",
    "Når ho koka kaffe etterpå, va det lyset i praten som holdt fingran varme.",
    "Mørket hang tungt over kaia sjøl midt på dagen, og lyden bar langt.",
    "Ingen trengte å sei kem vi venta på; havet veit alltid kem som mangla.",
    "I mørketida bære vinduslysan gata heim, stærkere enn ei mastlykt på floa.",
    "Små lys bli store nok når de peike rett vei.",
    "Da mørketida la sæ tungt over bygda, blei stemman lavere og ruta blank.",
    "Små lys i kjøkkenvindu va alt som skulle tel for å finne heim igjen.",
    "Når vinduslysan tok over for dagen, va det ingen som klaga høyt.",
    "Johannes rensa halsen og sa at sola bærre hadde tatt på sæ seinvakt.",
    "Når dagan blei kortere, blei lysan i vinduan viktigere enn klokka på kaia.",
    "Bamse va førstemann under vedovnen, som om han passa på gløran for oss.",
    "Marta tente lykta tidlig, og dampen fra koppen sto som en liten nordlysstripe.",
    "Johannes nikka rolig; han visste at sola fortsatt fantes, ho hadde bærre tatt sæ fri.",
    "I mørketida e dagslyset bærre en kort gjest som går før praten bli varm.",
    "Likevel visste kaia kem som snart kom inn; stillheta skifta takt da rette trinna nærma sæ.",
    "Når dagslyset bærre streife innom, kjennes kaia større enn vanlig.",
    "Da bli selskap en egen varme, og ei delt brødskive bedre enn ei ekstra lampe.",
    "Dagslyset va bærre innom kaia som en høflig gjest før det fór igjen.",
    "Resten av dagen kjente vi kværandre på stemmen; ansikta kom seint og litt forsiktig.",
    "Når natta vara gjennom dagen, bli kvær tur over dekket som en liten ekspedisjon.",
    "En av karan gikk med refleksvest og lo, som om han va sin egen fyrlykt."
  ],
  "midnattssol": [
    "Under midnattssola nekta Bamse å legge sæ; måsan jobba jo fortsatt.",
    "Vi lot han bestemme, for ingen av oss skjønte ka klokka betydde lenger uansett.",
    "Klokka meinte vi skulle heim da sola hang lav og sta over fjellan.",
    "Kaffekjelen tok en ny runde, og vi glømte tida med fullt overlegg.",
    "Midnattssola strekte fjorden utover som om ho trengte meir plass enn oss.",
    "Vi pakka seint og sa at alt kunne vent, bortsett fra lyset som nekta å gi sæ.",
    "Etter midnatt fikk Ronny en idé om å bygge nåkka av trepalla, tau og tru.",
    "Han sa han glømte tida med vilje; vi glømte å stoppe han.",
    "Marta dro gardinan for å jage midnattssola ut av stua et øyeblikk.",
    "Ho sa at dumskapen vises best uten solbriller, og vi tok hintet.",
    "Bamse patruljerte som om vakta aldri tok slutt i det kvite lyset.",
    "Tel slutt pekte Marta på dørmatta og sa at nu avslutte vi dagen sjøl.",
    "Johannes satt ute med en kopp som hadde gitt opp varmen for lenge sia og så utover havet som jobba.",
    "Han sa at midnattssola gjør dårlige ideer lette å finne og vanskelige å la være å gjennomføre.",
    "Lyset bretta fjorden utover tel dobbelt størrelse, og alle planan blei like store.",
    "Da vi endelig ga oss for kvelden, hadde Bamse for lengst funnet senga si under bordet.",
    "Natta nekta å skru av lyset og lot dagen stå på halv styrke.",
    "Ronny glømte klokka med god samvittighet og fulgte latteren bortover kaia.",
    "Midnattssola hang over fjellet som ei lampe som nekta å slås av.",
    "Vi skjønte at dagen måtte avsluttes manuelt, så Johannes sa rolig at kaffekjelen va stengt for i kveld.",
    "Natta nekta å bli mørk, ho sto bærre der og va dag i forkledning.",
    "Ingen hadde nåkka bedre argument enn ei tynn gardin og et gjesp som lyg.",
    "Natta nekta blankt, vinduan sto fulle av lys som om dagen hadde sett feil på klokka.",
    "Vi lot bua late som det va natt, med tykk gardin og tynne unnskyldninga.",
    "Klokka peip at det va på tide å gå heim, men kaia va fortsatt i dagslys og latter.",
    "Sola va uenig som bærre nord kan, og samtalan fant en runde tel.",
    "Klokka klang ellevilt på veggen i bua og minna oss på leggetid.",
    "Ingen fant et godt argument mot lyset, så Johannes slo av kaffetrakteren og kalte det et vedtak.",
    "Natta nekta å bli mørk, men Johannes brydde sæ lite om forhandlinga.",
    "Han sov alt da resten endelig satte sæ, som om søvn også går etter flo.",
    "Klokka på brakka peip om leggetid mens kaia lå lys som middag.",
    "I midnattssola ser du ekstra tydelig ka som e dumt, men du gjør det likevel.",
    "Midnattssola hang lav over fjellan og sa at kvelden va ung.",
    "Vi sa det motsatte og bar teina heim, men endte med kaffe og en time tel.",
    "Bamse runda kaia tre ganga og venta fortsatt på natta som aldri kom.",
    "Tel slutt la han sæ midt på brygga. Det va visst natt nok for han.",
    "Marta dro gardinan igjen som om ho kunne lær sola klokka.",
    "Det funka ikkje, men alle sov bedre av at ho prøvde.",
    "Midnattssola heng over fjellan og kaia e like våken som måsan.",
    "Johannes låste døra og la sæ da resten av bygda endelig kom på den tredje koppen."
  ],
  "skrei": [
    "Fisk, diesel og kaffe la spor i lufta heile veien bort tel mottaket.",
    "Når kassan endelig sto i ro på kaia, blei stegan lættere og praten mjuk.",
    "Johannes strauk tommelen over fisken før kniven traff og nikka bærre.",
    "Når han sa det va rett, trengte ingen kalender for å vite kor i sesongen vi va.",
    "Ronny slo ut arma og erklærte at nu begynne årets viktigste veke, i alle fall.",
    "Vi lot han rop, mens fingertuppan gjorde jobben de hadde lært av vinteran før.",
    "Båtan rulla inn så lasta at sjøen måtte flytt sæ litt.",
    "Ingen trengte forklaringa; hendern visste ka som venta før støvlan traff dekket.",
    "Skreien kom drivanes sørfra, kald og blank fra Barentshavet.",
    "Vi kjente det i hendern før vi såg det på loddet; kroppen husk sesongen bedre enn hodet.",
    "Marta sto ved kjøkkenbenken før sola, pakka mat som om døgnet hadde flere skift.",
    "Når skreien kjæm, bli tida alltid for kort, så ho send med to pauser ekstra.",
    "Kaia va i gang lenge før bygda rakk å gjesp, og plankan og pullertan svara med frostknirk.",
    "Når lukta av fersk skrei finn vegen inn gjennom døran, treng ingen, heller ikkje æ, en kalender for å forstå at sesongen e i gang.",
    "Før første bil starta oppi gata, sto kaia allerede og pusta kald damp.",
    "Mottaket slo på lysan og stemmen steg, som om veggan huska kordan det skulle være.",
    "Skreien dreiv sørover fra Barentshavet med kald vilje og blank rygg.",
    "Det va nok å hør krokene syng; ingen trengte kalender for å skjønn ka uke vi va i.",
    "Båtan kom siganes tungt inn gjennom rim på rekka, baugan bar meir enn prat.",
    "Mottaket slo på alt av lys, og stemman tok over der motorlyden slapp.",
    "Marta fylte nisteboksan så lokkan ga opp, ho visste kem som glømte å spise når det braka løs.",
    "Nede på mottaket våkna lysan og stemman, og heile bygda fant rytmen.",
    "Sesongen sto plutselig foran oss, du kjenna det i telefonan som ringa tidlig og kropper som går fortere.",
    "Når første kassan e på land, bli stegan mildere og praten varmere.",
    "Kaia va våken før bygda, og lukta av skrei og diesel la sæ tidlig over bryggan.",
    "Søvnen blei utsatt tel båtan va tømt, og ingen klaga.",
    "Ronny ropa at nu begynne det, årets viktigste tid, og vifta med lua som et flagg.",
    "Ingen trengte kalender; lyden av kjetting og kasselokk va klokke nok.",
    "Sesongen small i gang før sola rakk å kle sæ.",
    "Marta sendte oss ut med fulle matboksa; ingen sku arbeide sulten når havet krev sitt.",
    "Sesongen kom som et smell i døran på naustet.",
    "Søvnen blei flytta og flytta, helt tel kaffekjelen tok over nattevakta.",
    "Marta pakka mat for lange daga, med ost i tjukke skiva og ekstra brød nederst i sekken.",
    "Ho visste kor mye som gikk med når været slo om og arbeidet dro ut.",
    "Båtan kom tungt inn, rekkan lå dypere enn i går.",
    "'Tungt,' sa Johannes, og lot ordet gjelde både fangst, skuldra og dagan som venta.",
    "Ronny erklærte høyt at nu avgjøres alt, årets viktigste tid, og han hadde rett for en gangs skyld.",
    "Når skreien står på, bli døgnet for kort uansett klokke.",
    "Johannes strauk hånda over fisken og kjente kvaliteten før kniven traff.",
    "Marta pressa brødskiva på oss; ingen sku stå sulten med skarpe kniva i hendern.",
    "Båtan kom tungt inn med kjølen lav og praten kort.",
    "På brygga sto kaffekjelen klar og matpakkan åpna; ingen sku arbeide sulten på vår kai.",
    "Ronny slo ut arma og erklærte skreien for sælveste nyttåret for oss.",
    "Mottaket svarte med lys, rop og damp, som om bygda endelig huska ka den va laga for."
  ],
  "christmas": [
    "Kirkeklokkan bar over fjorden og landa mjukt på kaia som rim.",
    "Heile bygda sto i ro akkurat da, som om sjøen og hjartan telte samme takt.",
    "Ronny slepa et juletre som va breiere enn ytterdøra og nesten like selvsikkert.",
    "Marta rulla opp ermene, målte med blikket, og sa at form e forhandling, men gulvet har grenser.",
    "Marta satte fram en ekstra tallerken før nån rakk å spørre for kem den va.",
    "Ho kalte det bærre gammeldags høflighet; vi visste at ho meinte håp.",
    "Jula kom tel kaia med lys i mørket og ei lang skjøteledning som slo i vinden.",
    "Ingen kommenterte at alt va det samme som i fjor; det va nettopp derfor det kjentes rett.",
    "Johannes strauk hendern over søndagskjorta før han lukka knappen i halsen.",
    "Vi lot være å si at den va samme som i fjor; han e heller ikkje ny, heldigvis.",
    "Ronny slepte opp et juletre breiere enn døra på samfunnshuset.",
    "Vi holdt pusten tel han vridde det sidelengs og smilte, som om han hadde parkert en sjark innendørs.",
    "Jula kom tel kaia som ei lyslenke over mørket og stille fjord.",
    "Gamle vana sette sæ ved samme benken, og ingen hadde hastverk med å jage dem heim.",
    "Kirkeklokkan bar over fjorden som om lyden fant vegen for oss.",
    "Nån kom heim med snø i luggen, mens plassen etter en annen fortsatt sto tom.",
    "Jula kom tel kaia med lys i mørket og kakeboks på benken.",
    "Marta såg på pepperkakan våre og sa at forma kunne diskuteres, men smaken va heim.",
    "Bamse rulla sæ under julebordet som om det va oppdrag.",
    "Han våkna da en bit traff gulvet, og sovna igjen da det blei stille.",
    "Jula kom tel kaia med små lys i mørket og still sjø.",
    "Ronny va rørd og høflig taus heilt tel ribbelukta fant han; da blei han plutselig svært sosial.",
    "Kirkeklokkan bar over fjorden så sjøen skalv lett.",
    "Marta nikka andektig og sa at klokkeklangen va fin, men at resten av jula kunne diskuteres over kaffe og sirupssnippa.",
    "Kirkeklokkan bar over fjorden og la lokk på småkranglinga.",
    "Gamle vaner fikk sitte med ved bordet, men ingen lot dem ta siste ordet i år.",
    "Kirkeklokkan bar over fjorden og la sæ i naustveggen.",
    "Johannes nikka mot lyden, men blei først religiøs da ribba traff bordet.",
    "Bamse la sæ under julebordet og sukka tungt som en gammel kar.",
    "Ronny kikka ned og spurte om hunden også syntes det tok lang tid før ribba kom.",
    "Marta satte fram en ekstra tallerken for dem som ikkje rakk heim hit i år.",
    "Ronny sa lite tel ribba kom, da skålte han lavt for alle som fortsatt va på havet.",
    "Julelys speila sæ i svart fjære når første båten kom inn.",
    "Nån sprang i arman på sine, og stillheta rundt de som mangla, va det sterkaste lyset den kvelden."
  ],
  "easter": [
    "Ronny sto i solveggen og slo stavan i snøen og erklærte at skaren bære, nu e vi i gang.",
    "Fem minutt senere sto han tel livet, og alle nikka: påske.",
    "Påska kom med skarp sol, skare som sang under skian og votta som aldri rakk å tørke.",
    "Vi bar appelsin i lomman og mild forbannelse i munnvika, og kalte det fri.",
    "Bamse la sæ i sporet bak oss med nesa som kompass og varm pels mot vinden.",
    "Når lukta av niste tok over for fjellbjørka, passerte han alle og la sæ midt i flokken.",
    "Marta pakka appelsin, svart kaffe og tørre votta i sekken sammen med formaninga.",
    "Sola lovte oss lett dag, men vinden fikk siste replikk, og vi spiste i ly av en hyttevegg.",
    "Ronny ropte at skaren va stiv som stål, det e bærre å gi på.",
    "Vi sparte kommentaran tel etterpå, når buksa va full av sørpe og Ronny plutselig måtte justere fellen.",
    "Bamse holdt sæ i sporet tel nysnøen gjorde alt anonymt og vinden tok lukta.",
    "Da snudde han mot sekken tel Marta, og vi skjønte at fjellet hadde bestemt pausen.",
    "Marta la appelsin, kaffe og et lite teppe i sekken uten å spørre nån.",
    "Når vi delte nista på en stein og sola svei litt på nesa, va det påske uansett føre.",
    "Påska kom med skarp sol, sukkersnø og votta som blei tyngre for kvær bakke.",
    "Ingen sa nåkka før vi va tilbake på trappa, da klaga alle i kor.",
    "Johannes sto lenge og målte fjellsida med blikket før han nikka.",
    "Turen gikk fint, og klaginga kom først heim, da hælan meldte sæ.",
    "Kvær påske står Johannes og les fjellsida som ei gammel bok før han svar.",
    "Når vi står og venta mens kaffin bli kald, kalla vi det tradisjon.",
    "Påska kom med skarp sol og våte votta.",
    "Bamse fant pausbakken før oss andre og la sæ midt i solflekken som om han hadde reservert bord.",
    "Marta pakka appelsin og kaffe, og plutselig va halve turen redda.",
    "Skaren bar fortsatt ikkje, men humøret gjorde.",
    "Johannes kikka på fjellsida, mumla nåkka om hellinga og starta jevnt.",
    "Da vi fant steinan for pausen, satt han der allerede og holdt kaffekjelen i ro.",
    "Påska kom med skarp sol og votta som dryppa i skisporan.",
    "Sola lova varme, men vinden minna oss på at april har humor.",
    "Påska kom med skarp sol over kaia, smeltvatn i støvlan og votta som va klissvåte før formiddagen.",
    "Havet blunka vennlig, men været tok siste ordet som vanlig."
  ],
  "morning": [
    "Morran begynte før sola, med rim på rekka og stille prat som hang i pusten.",
    "Før lyset rakk å våkn, kom varmen fra kaffekjelen og maskinrommet.",
    "Morran starta før sola, sjøstøvlan knirka mot treverket og kaffelukta la sæ som et løfte.",
    "I det mørke lyset blei praten enklere, og sannheta hadde bedre plass.",
    "Marta åpna bua med nøkkeln som alltid finn rett vei, og kaffekjelen svarte med en gang.",
    "Når ho sto der, blei praten rett fram; ingen orka å pynt sæ for ho.",
    "Marta åpna bua, og den gamle hengsla sang lavt mot stillheta på kaia.",
    "For Johannes va akkurat den lyden god morgen, meir enn ord nån gang bli.",
    "Johannes løfta blikket mot skyan, smakte på vinden og lot bølgeskvulpet få første replikken.",
    "Sånn sa han god morgen; resten av oss svarte etterpå.",
    "Første kaffekoppen sto og trakk på benken ved døra, dampen steig som et lite fyrtårn.",
    "Den varma hendern før sola rakk å prøv.",
    "Første kaffekoppen sto og trakk på rekka, merka med hakk etter år.",
    "Johannes nikka mot den; sånn sa han god morgen uten å bruk opp ordan.",
    "Morran va i gang lenge før sola løfta sæ over moloen.",
    "Vi lot lyden av termosen åpne dagen, så kom resten etter.",
    "Kaia lå stille som ei tom stue før motoran rørte på sæ.",
    "Bamse hadde allerede krølla sæ midt på plattingen og erklært området trygt.",
    "Første kaffekopp sto og trakk i brakka, som om tia måtte våkne først.",
    "Da kom de ekte orda, rolig og uten pynt.",
    "Det va så stille på kaia at sjøl måsan venta med å skrike før motoran slo inn.",
    "Vi lot stillheta gå først, så kunne dagen følg etter.",
    "Morran kom før sola nådde over fjellan.",
    "Johannes lot et nikk være sin måte å si god morgen på, og resten måtte henge med.",
    "Kaia va stille som et inntrukket pust før motoran fant tonen.",
    "Varmen fra koppen kom før lyden, og folk blei litt meir menneske.",
    "Johannes måla været med blikket før han nikka tel nån.",
    "Marta sto klar med termos; det va varmen som hilste først.",
    "Johannes tok en runde med himmelen før han sa morgen.",
    "Bamse hadde for lengst valgt plassen sin ved rekka og godkjent dagen med et sukk.",
    "Før motoran brølte, lå kaia som i dvale.",
    "I den stillheta snakka folk sannere, som om saltet holdt igjen alt tullprat.",
    "Morran kom før lyset, og kaia va kald og stille.",
    "Bamse hadde allerede valgt plassen der sola alltid finn han først.",
    "Kaia sto heilt stille før den første nøkkelen vrei sæ i tenninga.",
    "Johannes kalla det havets god morgen og lot stillheta gå først."
  ],
  "night": [
    "Natta la sæ over moloen og lyktan blunka treigt.",
    "Johannes tok en ekstra runde med tauan, som om dagen må bindes før den får sove.",
    "Det siste lyset på bua slokka, og Ronny sa at vakta va over.",
    "Bamse sto fortsatt og speida mot moloen, for han trudde aldri helt på sånt.",
    "Natta la sæ mørk over moloen, våt som oljehyra på en dårlig dag.",
    "Havet sto fortsatt på vakt; det pusta aldri ut samtidig som oss.",
    "Kaia knirka annerledes etter midnatt, som et gammelt naust som ville ha fred.",
    "Marta samla krus og kveila tauet, for nån må lukke dagen skikkelig.",
    "Etter midnatt knirka kaia på en mørkere måte, som om plankan husk mer enn oss.",
    "Havet svara ikkje, men æ merka at det våkta likevel.",
    "Ronny sa han bærre skulle bli fem minutt tel og lente sæ mot rekka.",
    "Da lyset blinka tredje gang, skjønte vi at fyrlykta va bedre på tidsfrister enn han.",
    "Natta la sæ tung over moloen og dempa alle lyda tel pust.",
    "Fyrlykta sto igjen som siste vakt, og blunka oss heimover kvær gang mørket glømte.",
    "Johannes kjente på døra tre ganga før han gikk fra bua, gamle fingra som målte ro.",
    "Bamse løfta bærre et øye, som om han registrerte ny runde om fem minutt.",
    "Etter midnatt knirka kaia som om ho bar på hemmeligheta vi hadde glemt.",
    "Bamse reiste sæ og rista på hodet når nån kalte det stille.",
    "Det siste lyset fra bua gikk i svart og kaia dro pusten som etter ei lang vakt.",
    "Nån avslutta dagen pent, så morgenen hadde nåkka å gå på.",
    "Etter midnatt fikk kaia en anna lyd, som om plankan prata lavmælt mellom bølgan.",
    "Ute på neset blinka fyrlykta tilbake, den eineste som gadd å svar.",
    "Ronny lova fem minutt tel og begynte på ei historie som va eldre enn støvlan hans.",
    "Vi lot han prat, mens vi låste alt så dagen kunne legg sæ.",
    "Ronny sa han bærre skulle bli fem minutt tel ved rekka.",
    "En time etter sto han fortsatt og vokta mørket ilag med bølgan, og æ lot han vinne den vakta.",
    "Det siste lyset på kaia blei slukka, og lyden fra dagen la sæ flat.",
    "Ute på moloen blunka fyrlykta som en sta venn, og holdt oss med selskap heilt tel floa snudde."
  ],
  "ronny": [
    "Ronny fant fram verktøykassa uten et ord.",
    "Da visste alle at planen hadde endra sæ.",
    "Ronny klappa motorlokket.",
    "Nån ganga virka det bedre enn å banne.",
    "Ronny kom med kaffekoppen i hånda.",
    "Verktøyet fikk venta et halvt minutt tel.",
    "Ronny fant skruen under benken.",
    "Akkurat der alle hadde sett tre ganga allerede.",
    "Ronny la skiftenøkkelen på benken.",
    "Han hadde allerede bestemt sæ for å prøv én gang tel.",
    "Ronny fant ei skrue i lomma på oljehyra.",
    "Ingen visste kor lenge den hadde venta der.",
    "Ronny slo lett på motorlokket.",
    "Han kalla det feilsøking.",
    "Ronny hadde olje på fingran og kaffe på oljehyra.",
    "Dagen va godt i gang.",
    "Kaffekjelen kokte over med et lite fres.",
    "Ronny meinte det va et godt tegn.",
    "Ronny kom tilbake med feil verktøy.",
    "Han brukte det likevel.",
    "Ronny fant ei løsning som krevde både tau og plank.",
    "Det gjorde den straks meir troverdig.",
    "Ronny satte sæ på huk ved motoren.",
    "Resten av verden fikk vent.",
    "Ronny tørka hendern på buksa.",
    "Buksa hadde for lengst gitt opp.",
    "Tauverket slo mot masta.",
    "Ronny sa han skulle ordn det seinere.",
    "Ronny dro i startsnora en gang tel.",
    "Motoren svarte med taus protest.",
    "Ronny fant bolten som va borte under foten sin.",
    "Det kalte han framgang.",
    "Ronny fant fram hammeren.",
    "Det betydde ikkje nødvendigvis at nåkka måtte slås.",
    "Ronny lo før motoren starta.",
    "Det sparte han for litt banning.",
    "Ronny hadde glømt målebåndet.",
    "Han målte med øyemål og selvtillit.",
    "Ronny pekte mot naustet.",
    "Planen blei tel underveis som vanlig.",
    "Ronny satte fra sæ kaffekoppen.",
    "Nu måtte teorien prøves i praksis.",
    "Ronny tørka av propellen med ei fille.",
    "Den fortjente en ny sjanse.",
    "Ronny fant en gammel bolt i lomma.",
    "Den kunne sikkert brukes tel nåkka.",
    "Ronny klappa båtsida.",
    "Nån båta likte litt oppmuntring.",
    "Ronny dro ullhua bakover på haue.",
    "Da va det arbeidstid.",
    "Ronny fant enda en grunn tel å hente verktøykassa.",
    "Ingen spurte om grunnen. De hadde sett verktøykassa før.",
    "Ronny banka lett på rekka.",
    "Alt som holdt, fortjente litt ros.",
    "En måse sklei elegant på vinden.",
    "Ronny prøvde ikkje det samme.",
    "Ronny lo av planen sin.",
    "Det va første gangen den dagen planen blei bedre.",
    "Ronny pekte mot en skrue ingen andre hadde sett.",
    "Det va ikkje skruen som gjorde folk urolig.",
    "Ronny lukka verktøykassa.",
    "Denne gangen holdt reparasjonen.",
    "Ronny la skiftenøkkelen fra sæ.",
    "Kaffepausen hadde han gjort sæ fortjent tel.",
    "Ronny fant en plankebit som kunne redde heile prosjektet.",
    "Resten av prosjektet va fortsatt på jakt etter sitt.",
    "Ronny satte sæ på rekka.",
    "Den holdt denne gangen også.",
    "Ronny fant fram arbeidshanskene.",
    "Nu blei det alvor.",
    "Ronny fant ei ny omvei.",
    "Den virka enklere enn den gamle.",
    "Ronny fant fram lommelykta midt på dagen.",
    "Det kunne bli mørkt under motorlokket.",
    "Ronny såg på skyan.",
    "Han vurderte om prosjektet tålte litt regn.",
    "Ronny fant fram teip.",
    "Det redda meir enn folk trudde.",
    "Ronny fant en ny måte å løse det gamle problemet på.",
    "Det gamle problemet va fortsatt det mest stabile i heile prosjektet.",
    "Ronny klødde sæ i haka.",
    "Da visste alle at ei løsning va på vei.",
    "Ronny tørka av verktøyet før han la det bort.",
    "Ingen sa nåkka. Det va første gangen verktøyet hadde vært ferdig før han.",
    "Ronny tok av sæ ullhua og rista regndråpan av den.",
    "Det va det nærmeste han kom en værmelding.",
    "Ronny fant den delen alle trudde va borte.",
    "Han hadde sjøl lagt den på en plass ingen ville lete.",
    "Ronny satte sæ på benken for å knyte skolissa.",
    "Kaffen gjorde pausen litt lengre enn planlagt.",
    "Ronny tørka hendern på filla.",
    "Jobben va ferdig for nu.",
    "Ronny tok en slurk kaffe og så ut som verden ordna sæ.",
    "Det va før han så på motoren igjen.",
    "Ronny fant ei løsning med ståltråd.",
    "Det va ikkje første gangen.",
    "Ronny flirte da skiftenøkkelen lå i baklomma heile tida.",
    "Han fant den akkurat der alle andre visste den va.",
    "Ronny meinte det holdt med én strips tel.",
    "Denne gangen gjorde det faktisk det.",
    "Ronny fant blyanten bak øret.",
    "Der hadde han funnet den sist òg.",
    "Ronny lukka lommekniven med et lite klikk.",
    "Det va lyden av at nåkka endelig va ferdig.",
    "Ronny fant endelig den rette skruen i den siste boksen.",
    "Det va synd resten av prosjektet trengte tre andre.",
    "Ronny fant igjen isskrapa da vinteren nesten va over.",
    "Han fant den i tide tel neste vinter.",
    "Ronny flirte da snøskuffa sto akkurat der han hadde satt den fra sæ.",
    "Han kalte det system.",
    "Ronny fant et skeivt hengsel og retta det med to slag.",
    "Det va nok måling for den jobben.",
    "Ronny målte to ganger og saga én gang.",
    "For en gangs skyld va det ingenting å snakk om etterpå.",
    "Ronny åpna motorlokket og fant problemet før han fant verktøyet.",
    "Problemet hadde tydeligvis ikkje venta på verktøykassa.",
    "Ronny tok høtten fram før fesken va ved båten.",
    "Johannes meinte det oppsummerte arbeidsmetoden hans.",
    "Ronny hadde egna halve lina med stor entusiasme.",
    "Marta oppdaga at han hadde glemt agnet på resten.",
    "Ronny sa han kunne andøv og snakk samtidig.",
    "Båten begynte straks å gå sideveis.",
    "Ronny knøt en knute han hadde sett på nettet.",
    "Johannes la på en knute som hadde sett sjø.",
    "Ronny fant fram sydvesten etter at han blei våt.",
    "Han kalte det erfaring i sanntid.",
    "Ronny sa dreggen satt bom fast.",
    "Johannes spurte om det ikkje va heile poenget.",
    "Ronny lovte å rydda linebøtta etter turen.",
    "Løftet blei ligganes nederst sammen med resten.",
    "Ronny sa han hadde effektivisert fortøyninga.",
    "Nu va begge tauan knytt i samme bøye.",
    "Han hadde sett en video om motoren.",
    "Motoren hadde tydeligvis ikkje sett den samme.",
    "Ronny bygde ei hylle uten å måle veggen.",
    "Veggen viste sæ å ha egne mål.",
    "Ronny kalte strips ei midlertidig løsning.",
    "Stripsen blei eldre enn planen.",
    "Han lagde hurtigkobling på dieselslangen.",
    "Den kobla sæ hurtigst fra.",
    "Ronny sa reservedelen va universell.",
    "Det betydde at den passa like dårlig overalt.",
    "Ronny sa reparasjonen holdt heile sesongen.",
    "Sesongen varte tel tirsdag.",
    "Ronny sa det va en investering.",
    "Marta spurte koffer investeringa allerede trengte tauing.",
    "Ronny sa han trengte litt rom.",
    "Marta ga han naustet og en kost.",
    "Ronny meinte kartet va feil.",
    "Fjellet sto dessverre på sitt.",
    "Ronny målte tre ganga.",
    "Ingen av målan va like."
  ],
  "specials": [
    "Havet blei heilt svart midt på dagen.",
    "I dag bør du ikkje inngå avtaler med folk som smile for fort.",
    "Alle måsan forlot kaia samtidig.",
    "Nån e på vei inn med meir selvtillit enn vett.",
    "Fyret blinka én gang for mye.",
    "Du får et valg som ser trygt ut og ikkje e det.",
    "Ei gammel bøye dreiv mot land uten strøm.",
    "Nåkka du trudde va borte, finn veien tilbake.",
    "Bamse lukta på dæ og nøs. Æ ville ikkje tatt det personlig, men æ ville notert det.",
    "I dag bør du stole på instinktet før forklaringa.",
    "Kaffen smakte salt uten at nån hadde rørt den.",
    "En samtale bli ærligere enn planlagt.",
    "Nordlyset dukka opp midt i en samtale. Det va enten et tegn eller dårlig timing.",
    "En sjelden mulighet viser sæ før du føler dæ klar.",
    "En båt kom inn uten lyd.",
    "Nån bringa nyheta de helst skulle sluppet å fortell.",
    "Marta satte fram en ekstra kopp uten å sei nåkka.",
    "Nån du ikkje har hørt fra, kjæm nærmere igjen.",
    "Johannes tok på sæ selskinnsjakka før frokost.",
    "Det bli enten høytidelig eller dyrt.",
    "Alle klokkene på kaia stoppa samtidig.",
    "Det va ikkje tida som va problemet.",
    "Ronny leverte tilbake et verktøy før nån ba om det.",
    "Ingen gikk hjem tidlig den dagen.",
    "Havet frøs rundt én enkelt båt.",
    "Nån hadde blitt ståanes for lenge i samme valg.",
    "Postbåten kom med en tom kasse merka «haster».",
    "Det va omtrent så mye innhold som i planen.",
    "Mottaket blei låst midt på dagen.",
    "Det va første gang folk forsto at nåkka faktisk va alvorlig.",
    "En torsk blei funnet med en nøkkel i kjeften.",
    "Døra den passa tel, va allerede åpen.",
    "Måsan stilte sæ på rekke langs moloen.",
    "De venta ikkje på fisk. De venta på konsekvensan.",
    "En gammel radio i bua begynte å spille uten strøm.",
    "Sangen handla om nån som burde ha dratt tidligere.",
    "Båten kom inn uten fører, men med varm kaffe.",
    "Nån hadde forlatt den i større hast enn vett.",
    "En konvolutt dreiv inn med floa.",
    "Navnet ditt va tørt.",
    "Lykta på moloen slokna i klart vær.",
    "Nån hadde valgt å ikkje se.",
    "Det kom ferske spor ut av et låst naust.",
    "Det e ikkje alt som treng ei åpen dør.",
    "En gullring dukka opp i torskelevera.",
    "Ingen på kaia ville innrømme at de kjente den igjen.",
    "Måsan forsvant i tre dager.",
    "Da de kom tilbake, va Ronny allerede i gang.",
    "Ferga kom inn uten lys.",
    "Likevel sto nån klar og venta.",
    "En gammel not kom opp full av brev.",
    "Ingen av dem va sendt tidsnok.",
    "Vannet rundt brygga blei svart i ett minutt.",
    "Det va lenge nok tel å vis ka som lå under.",
    "En måse satte sæ på skuldera di og nekta å fly.",
    "Nån må åpenbart pass på dæ.",
    "Heile kaia våkna med alle fortøyningan løst knytt.",
    "Ingen båt hadde flytta sæ, men alle visste at nån hadde vært der.",
    "Det kom en sjark inn uten navn på sida.",
    "Johannes kjente ho igjen på lyden.",
    "Marta fant et brev i kaffeboksen fra en mann som hadde vært død i tretti år.",
    "Det sto at ho måtte sette fram én kopp tel.",
    "Fyrlykta slukna idet ferga la fra.",
    "På dekket sto en passasjer ingen hadde sett gå om bord.",
    "En kasse fersk skrei sto på mottaket midt i juli.",
    "På lokket sto morgendagens dato.",
    "Ronny kom med en plan som faktisk virka.",
    "Det va da Johannes begynte å leit etter feilen.",
    "Alle bildan i bua hang plutselig på skeive.",
    "Bærre det av Johannes sto rett.",
    "En gammel telefon ringte i den nedlagte kiosken.",
    "Da Marta løfta røret, hørte ho bærre bølga og sitt eget navn.",
    "Havet trakk sæ ut av bukta og blei borte i ti minutt.",
    "I botnen sto en benk ingen hadde sett før.",
    "Bamse kom inn gjennom døra, våt og grå rundt snuten.",
    "Ingen hadde sett han siden den siste vinteren tel Johannes.",
    "En båt med lys i alle vindu dreiv forbi moloen uten lyd.",
    "På dekket satt alle dem kaia fortsatt savna.",
    "Postbåten leverte en nøkkel merka med navnet ditt.",
    "Ingen i bygda kjente døra den tilhørte.",
    "Det begynte å snø bærre over naustet tel Ronny.",
    "Inne sto verktøykassa åpen og alt va ryddig.",
    "Ei kiste kom opp i garnet uten rust eller groe.",
    "Da de åpna den, lå det bærre en varm kaffekopp der.",
    "Klokka på fergekaia slo tretten slag.",
    "Ferga som kom etterpå sto ikkje i ruta.",
    "En fremmed kvinne satte sæ på den tomme stolen i bua.",
    "Marta serverte kaffe uten å spørre kem ho va.",
    "Alle motoran på kaia starta samtidig uten nøkkel.",
    "Én båt mangla da lyden stilna.",
    "Det lå et ferskt fotografi av morgendagen på sløyebenken.",
    "Du sto i bakgrunnen og såg ut som du visste.",
    "Nordlyset forma et navn over fjorden.",
    "Johannes sa det én gang og nekta å gjenta det.",
    "En gammel dregg kom opp med et gullur fortsatt i gang.",
    "Viseran stoppa først da du tok i det."
  ],
  "openings": [
    "Det va stille på kaia heilt tel navnet ditt kom opp.",
    "Æ skulle egentlig holde kjeft i dag. Så dukka du opp.",
    "Havet va rolig i morges. Det e meir enn æ kan sei om det som kjæm.",
    "Sett dæ. Det hær bli ikkje bedre av at du står.",
    "Æ har sett tegn i fjæra før. Ditt va vanskelig å overse.",
    "Det begynte med en måse og endte med at æ tenkte på dæ.",
    "Æ spurte været om råd. Det ba mæ holde et øye med dæ.",
    "Det hær e ikkje et værvarsel. Det e oppfølging.",
    "Æ hadde en rolig dag planlagt. Så slo tanken på dæ inn fra vest.",
    "Det lukta kaffe, tang og dårlig vurderingsevne.",
    "Før du sei nåkka: Æ har hørt den forklaringa før. På kaia. Fra dårligere folk.",
    "Havet trakk sæ tilbake. Det burde du kanskje også gjort.",
    "Æ fant navnet ditt mellom flo og fjære. Det va ikkje der æ håpa.",
    "Det hær kunne vært hyggelig. Men nu e vi allerede i gang.",
    "Du ser ut som en som treng sannheta før første kaffekopp.",
    "Det va nordavind i natt. Den tok med sæ nåkka om dæ.",
    "Det va nåkka med lyset over moloen i morges. Det pleie å bety at folk har tenkt for lite.",
    "Æ kom før måsan. Det skjer bærre når dagen har nåkka å skjul.",
    "Havet va blankt i morges. Det e aldri et løfte.",
    "Det hær begynte før du kom. Du e bærre den siste som fikk vite det.",
    "Æ hørte navnet ditt i vinden. Den sa det ikkje pent.",
    "Kaia va tom, men det va likevel nån som hadde gjort nåkka dumt.",
    "Du ser ut som en som har fått et råd på kaia og gjort det motsatte.",
    "Nåkka har løsna. Æ håpe for din del det ikkje va fortøyninga.",
    "Det blei stille da du kom. Sjøen har gode instinkt.",
    "Æ ska ikkje spørre ka du har gjort. Det visa sæ snart.",
    "Det lukta diesel, tang og en avgjørelse tatt for fort.",
    "Måsan har samla sæ. Det e sjelden for å gratuler nån.",
    "Det hær kan gå bra. Det e akkurat derfor æ e urolig.",
    "Æ såg spor i fjæra. De gikk ut, men ikkje inn.",
    "Det va godt humør på mottaket i morges. Hold dæ fast.",
    "Postbåten va tidlig. Nån har det travelt med å lever problem.",
    "Ronny va taus. Det e omtrent som et nødbluss.",
    "Du kom på et dårlig tidspunkt. Sannheta va akkurat blitt varm ved kaffekjelen.",
    "Havet har ikkje sagt nei. Det har bærre slutta å svar.",
    "Det va frost på brygga. Likevel va det du som så mest usikker ut.",
    "Æ fant en løs knute. Det pleia å start sånn.",
    "Det står ei bøtte midt på kaia. Ingen eie den, men alle veit kordan den kom dit.",
    "Æ tenkte vi kunne ta det rolig. Så hørte æ motoren din.",
    "Nån har satt fra sæ støvlan feil vei. Det e et tegn på hastverk.",
    "Dagen va fredelig på kaia heilt tel folk begynte å mene nåkka.",
    "Det e lenge siden sjøen va så stille. Altfor lenge.",
    "Æ har et svar. Du kjæm tel å ønske æ hadde et anna.",
    "Det hær e ikkje begynnelsen. Det e kvitteringa.",
    "Kaffekoppen din sto på feil bord i morges. Det passa dessverre med resten.",
    "Det første æ hørte i morges, va naustdøra som ikkje blei lukka.",
    "Det kom et «jaja» fra mottaket før frokost. Da veit du det e alvor.",
    "Du ser ut som en som har tatt med forklaringa og glømt lærdommen.",
    "Det står en tom kasse ved sløyebenken. Nån har levert mindre enn de lovte.",
    "Æ hadde et mildere svar. Vinden tok det.",
    "Før du begynne å forsvare dæ: æ har allerede hørt begge versjonan.",
    "Moloen va full av skum i natt. Det e sjelden bærre været som har rota.",
    "Det hær e dagen du finn ut om tauet va knytt eller bærre lagt pent.",
    "Ferga gikk uten dæ. Kanskje det va første gode avgjørelsen i dag.",
    "Æ såg Johannes snu sæ to ganga. Det gjør han bærre når nåkka ikkje stemme.",
    "Marta satte fram den store kaffekanna. Ho forventa en lang forklaring.",
    "Det e vått på dørken og tørt i tanken. Æ ville begynt med sannheta.",
    "Nån har malt over navnet, men ikkje historia.",
    "Du kom akkurat tidsnok tel å hør ka du burde ha skjønt i går.",
    "Det ligg en arbeidshanske igjen på vinsjen. Nån har sluppet taket litt for tidlig.",
    "Æ vurderte å la dæ lær det sjøl. Så kom æ på kor dyrt det pleie å bli.",
    "Bua lukte kaffe og dårlig samvittighet. Sett dæ.",
    "Det hær va enklere før du begynte å forklar.",
    "Æ har sett på saken fra alle sida. Den e skeiv fra dem også.",
    "Nån har skrudd opp radioen. Det betyr at motoren sei nåkka viktig.",
    "Dagen begynte med at Ronny sa «teoretisk sett». Nu e vi hær.",
    "Det står en båt uten lanterne ved moloen. Nån satse hardt på å bli misforstått.",
    "Første kaffekopp va bitter. Den andre nevnte navnet ditt.",
    "Æ har ikkje kommet for å trøste dæ. Men du kan få kaffe.",
    "Det e lite vind og mye uro. Den kombinasjonen bør du respektere.",
    "Du har brukt lang tid på å komme fram tel feil spørsmål. Kaffekoppen e allerede kald.",
    "Det e ikkje dårlig nytt. Det e bærre nyheta du har unngått."
  ],
  "wisdom": [
    "Den som alltid har en forklaring, har sjelden tid tel å lær.",
    "Det e ikkje motvind når kursen e feil.",
    "Folk visa kem de e når planen ryka og nordavinden står på.",
    "Du treng ikkje vinne diskusjonen hvis du allerede har mista poenget.",
    "Stillheta i bua e ikkje tom. Den e full av det folk ikkje fikk sagt før kaffen blei kald.",
    "Et nei før avgang e billigere enn et ja ute i sundet.",
    "Du kan ikkje ro fra det du tar med dæ i båten.",
    "Den som skylde på været, har ofte glemt å fortøye.",
    "Respekt e det som står igjen når sjarmen har gått hjem.",
    "Det e forskjell på å være snill og å gjøre sæ liten.",
    "Du får ikkje ro av å late som lekkasjen ikkje e der.",
    "En dårlig vane bli ikkje tradisjon bærre fordi den har vært lenge.",
    "Den som aldri skifta mening, har ofte slutta å følg med.",
    "Du kjenne folk best på det de gjør når ingen står på kaia og ser.",
    "Det e dyrt å spar sannheta tel etter at båten har gått.",
    "Du kan savne en båt og fortsatt vite at ho lekk.",
    "Å gå videre betyr ikkje at leia bak dæ va bortkasta.",
    "Det du ikkje fortøye, må du før eller seinere svømme etter.",
    "Stillheta etter at motoren stoppa, e også et svar.",
    "Du kan vent på bedre vær tel båten råtna.",
    "En dårlig knute ser fin ut helt tel det bli belastning.",
    "Det e lett å være modig på land.",
    "Folk som har dårlig tid, har ofte brukt god tid på feil ting.",
    "Det du skyv foran dæ, ligg fortsatt i leia.",
    "Du treng ikkje vite alt. Men du bør vite ka du ikkje veit.",
    "Det e forskjell på å stå fast og å ha kasta anker.",
    "Nån går på skjær fordi de aldri ser opp fra kartet.",
    "Et løfte uten handling e bærre lyd over vann.",
    "Du kan ikkje reparere en lekkasje med bedre humør.",
    "Den som alltid har rett, står som regel aleina på brygga.",
    "Det e dyrt å late som problemet e billig.",
    "Det du lar passere på kaia én gang, står fort på arbeidslista.",
    "Du ser ikkje strømmen før du prøv å gå imot den.",
    "Ei åpen naustdør e ikkje det samme som en invitasjon.",
    "Det finnes folk som beklaga vinden mens de sjøl har løsna tauet.",
    "Du kan ro i ring og fortsatt være sliten.",
    "Nåkka bli ikkje sant bærre fordi det blei sagt høyt.",
    "Den som aldri snur før moloen, kjæm ikkje alltid heim.",
    "Det e lættere å love i medvind.",
    "Du bør hør ekstra godt etter når alle e enige for fort.",
    "Et godt råd tåle at du søv på det.",
    "Den som rydda etter sæ, slæpp å forklar så mye.",
    "Du kan ikkje gjømme rust med mørk maling.",
    "Folk visa kordan de e når tauet stramma sæ.",
    "Du kan kjenne rett kurs og fortsatt ha klump i magen.",
    "Det e grenser for kor lenge ei bøye kan late som den e land.",
    "Ei unnskyldning uten endring e bærre samme feil med høfligere stemme.",
    "Du treng ikkje vinne over havet. Det hold å forstå når du ska snu.",
    "Det e lite hjelp i et kompass du bærre ser på når du e enig.",
    "Det du ikkje tør spørre om, står ofte allerede i blikket over kaffekoppen.",
    "En mann kan lyge med munnen. Båten gjør det med lyda.",
    "Det finnes rolige folk med storm inni sæ.",
    "Den som bær alt aleina, får sjelden begge hender fri.",
    "Du kan ikkje være både fyrlykt og tåke.",
    "Ei grense træng ikkje lyd. Fortøyninga gjør jobben stille.",
    "Nån ganga e det klokeste å gå før båten synk.",
    "Den som alltid rydda opp, bli tel slutt behandla som en del av rotet.",
    "Det e ikkje tillit når du må sjekke fortøyninga to ganga.",
    "Du kan tilgi uten å gi naustnøkkelen tilbake.",
    "Ro e ikkje fravær av liv. Det e når bærre vinden får lag bråk.",
    "Du kan stå i stormen uten å fortøye der.",
    "Du kan ikkje tette samme lekkasje med materialan som laga den.",
    "Du træng ikkje bli hard. Bærre tydelig nok tel at tauet hold.",
    "Et løfte som bærre gjelder i godt vær, e en værmelding."
  ],
  "endings": [
    "Det va det. Resten får du klar uten å gjøre det verre.",
    "Gå nu. Sannheta bli ikkje mildere av at du står på kaia.",
    "Du veit ka du må gjøre. Det e derfor du blei så stille.",
    "Ta det med ro. Men ta det på alvor.",
    "Det ordna sæ kanskje. Men ikkje av sæ sjøl.",
    "Sånn e det. Havet send ikkje kvittering.",
    "Resten e ditt ansvar. Æ har allerede gjort den vanskelige delen.",
    "Du får én sjanse tel å late som du ikkje skjønte det.",
    "Det va dagens råd. Misbruk det med måte.",
    "Nu kan du gå. Tenk før du gjør resten.",
    "Det hær va gratis. Neste gang kosta det stolthet.",
    "Ta med dæ det som traff. Resten va sikkert tel nån andre.",
    "Æ har sagt mitt. Havet får ta klagen.",
    "Gjør ka du vil. Men ikkje kall det et uhell etterpå.",
    "Du treng ikkje takke. Bærre slutt å gjøre det samme.",
    "Det finnes lættere svar. De va bærre ikkje sanne.",
    "Gå før du begynne å forklar dæ bort.",
    "Det va konklusjonen. Følelsan dine får skrive vedlegget.",
    "Vi avslutte der, mens du fortsatt har litt verdighet igjen.",
    "Det va det. Resten får havet ta.",
    "Nu veit du nok. Ka du gjør med det, e ikkje mitt tau.",
    "Æ har sagt mitt. Måsan får ta klagen.",
    "Der har du svaret. Det va ikkje penere i morges.",
    "Nu får du gå før sannheta og kaffen bli kald.",
    "Det e alt æ har. Og meir enn du ba om.",
    "Resten står mellom dæ og fjæra.",
    "Nu e det din tur å late som du ikkje visste.",
    "Ta det med dæ. Men ikkje legg det i båten min.",
    "Æ ville tenkt mæ om. Men ikkje så lenge som du pleie.",
    "Det bli ikkje klarere av at vi står hær.",
    "Nu går æ. Du kan bli igjen med forklaringa.",
    "Havet har hørt nok. Det har æ også.",
    "Det va dagens sannhet. I morgen kjæm regninga.",
    "Du får bruk det før Ronny gjør det.",
    "Nu e kaffen kald. Det betyr at vi e ferdig.",
    "Æ har ingen bedre avslutning. Det har sjelden livet heller.",
    "Der slapp du billig unna.",
    "Nu veit du koffer måsan skreik.",
    "Det va ikkje trøst. Det va retning.",
    "Gå rolig. Brygga husk folk som spring.",
    "Resten får du lær uten publikum.",
    "Det hær va gratis. Neste gang koste det erfaring.",
    "Nu kan du enten forstå det eller gjenta det.",
    "Æ ville ikkje satset på at havet glømme.",
    "Ta vare på rådet. Kvitteringa kan du kaste.",
    "Det bli ikkje meir sant av at æ gjentar det.",
    "Nu lukke vi den luka.",
    "Ferdig snakka. Før vinden skifte mening.",
    "Nu e det sagt. Ikkje kall inn resten av kaia.",
    "Ta rådet før stoltheita rekker å pakk det bort.",
    "Resten bli mellom dæ og det du allerede veit.",
    "Nu kan du gå. Forklaringa kan rydda etter sæ sjøl.",
    "Det va alt. Og akkurat nok tel å ødelegge en dårlig plan.",
    "Legg fra dæ unnskyldninga før du går. Den tar stor plass.",
    "Nu får handlinga overta. Ordan har hatt lang nok vakt.",
    "Gå heim og gjør én ting riktig før du fortell nån om det.",
    "Der e kursen. Du træng ikkje holde tale om avgangen.",
    "Ta med dæ sannheta. Resten kan bli igjen på kaia.",
    "Æ har gjort min del. Nu får du gjøre meir enn å nikke.",
    "Det hær bli ikkje bedre av en tredje kaffekopp. Men ta den med.",
    "Gå før Ronny tilbyr hjelp.",
    "Det va dagens råd. Ikkje vent tel det bli gårsdagens anger.",
    "Nu kan du velge. Været har allerede gjort det.",
    "Resten e ikkje komplisert. Bærre ubehagelig.",
    "Nu går æ inn. Havet har bedre tålmodighet med dæ.",
    "Du får én natt på dæ. Ikkje bruk ho på nye forklaringa.",
    "Nu veit du kor det lekker. Finn fram verktøyet.",
    "La det som e slutt, få slæpp å fortsette av høflighet.",
    "Gå med rett rygg. Du træng ikkje bære alt heim.",
    "Det va siste advarsel med kaffe inkludert.",
    "Nu får du slutte å spørre vinden om lov.",
    "Ferdig. Før vi begynne å pynte på sannheta."
  ],
  "signs": [
    "En måse satt med ryggen mot havet. Nån har bestemt sæ uten å tenk.",
    "Kaffen kokte over før sola kom opp. En liten sak bli større enn planlagt.",
    "Tauet løsna uten vind. Nån du stola på, følga ikkje heilt med.",
    "Tre båta kom inn samtidig. Du får fleire valg enn du ba om.",
    "Nordavinden snudde ved flo. Det du trudde va avgjort, kjæm tilbake.",
    "En tom stol sto våt etter regnet. Nån savna det de sjøl gikk fra.",
    "Motoren starta på første drag. I dag bør du handl før du rekker å tvil.",
    "En måse slapp maten og flaug. Nån gir opp nåkka de egentlig ville ha.",
    "Fjæra lå uvanlig blank. En hemmelighet e nærmere overflata enn før.",
    "Lyset sto på i naustet ved daggry. Nån har vært våken med samme tanke som dæ.",
    "Regnet traff bærre den ene sida av kaia. Du ser bærre halve bildet.",
    "Røyken la sæ lavt over nausttakan. Folk holde tilbake meir enn de sei.",
    "Naustdøra slo igjen uten trekk. Et valg bli tatt før du e klar.",
    "En kaffekopp sprakk uten å falle. Nåkka tåle mindre enn det ser ut som.",
    "Havet bar inn et gammelt tau. Fortida kjæm tilbake med arbeid tel dæ.",
    "En måse fulgte båten heilt inn. Nån gir sæ ikkje før de får svar.",
    "Klokka stoppa midt i floa. Du har utsatt nåkka lenge nok.",
    "Det va stille mellom bølgan. Vent et sekund før du fyller det med din egen lyd.",
    "Tre måsa satt med ryggen mot havet. Nån har hørt et råd og tenkt å ignorere det.",
    "Ei fortøyning sang i vindstilla. Nåkka e strammere enn det ser ut.",
    "Kaffen skvulpa uten at båten rørte sæ. Nån e urolig før de veit koffer.",
    "Postbåten la tel uten å tute. Nåkka kjæm som ikkje vil varsles.",
    "En fiskekasse sto opp ned ved mottaket. Planan e snudd, men ingen har sagt det høyt.",
    "Måsan lot rekene ligge. Det e et dårligere tegn enn folk trur.",
    "Lyset på moloen blinka én gang for mye. Nån får en ny sjanse de ikkje har bedt om.",
    "Ei åre dreiv inn uten båt. Nån har mista retninga før de merka det.",
    "Bensinpumpa stoppa på et rundt tall. Nåkka bli avslutta før tida.",
    "En måse satt på postkassa. Nån får beskjed de ikkje vil ha.",
    "Frostrøyken gikk mot vinden. Nån prøv å presse fram nåkka som ikkje e klart.",
    "Det lå fersk tang midt på brygga. Havet har levert et varsel uten konvolutt.",
    "En tom kaffekopp sto varm på bordet. Nån har gått før samtalen va ferdig.",
    "Mottaksdøra sto åpen i regnet. Nån har glømt ka de skulle beskytte.",
    "Motoren starta på første drag. Det e nesten meir mistenkelig enn når den ikkje gjør det.",
    "En hund nekta å gå ut på brygga. Dyr har kortere vei tel vettet.",
    "Det va ferske fotspor rundt båten, men ingen på kaia. Nån har vært hær før dæ.",
    "Kaffekoppen på mottaket blei tømt uten ett ord om været. Nåkka alvorlig har skjedd.",
    "Ronny møtte opp med verktøykassa lukka. Det e et tegn på at planen e verre enn vanlig.",
    "Havet trakk sæ langt tilbake uten vind. Nåkka gir plass før det kjæm med kraft.",
    "Ei line kom opp uten krok. Nån har brukt mye innsats på feil ende.",
    "Det brant lys i naustet før daggry. Nån skjula arbeid de ikkje vil forklar.",
    "En fender dreiv aleina langs moloen. Nån har løsna sæ fra det som skulle hold dem fast.",
    "Sløyebenken va rein midt i sesongen. Nåkka e enten over eller aldri begynt.",
    "En måse hakka på et vindu. Nåkka ute vil inn, og det e sjelden bærre været.",
    "Ferga tuta to ganger i tåka. Nån får en advarsel tel.",
    "Det lå en arbeidshanske ved bensinpumpa. Nån har forlatt skiftet halvveis.",
    "Vinden snudde idet navnet ditt blei nevnt. Det e enten skjebne eller dårlig timing.",
    "En kjetting lå stram uten båt. Nåkka hold fast i ingenting.",
    "Postbåten hadde ingen post. Likevel kom den. Nåkka e på vei som ikkje kan skrives.",
    "Ei gammel bøye slo mot kaia heile natta. Fortida har dårlig respekt for åpningstider.",
    "En kråke satt på rekeskiltet. Nån kjæm for nåkka de ikkje har betalt for.",
    "Det sto to par støvla utenfor naustet. Bærre ett par gikk derfra.",
    "Havet va grønt langs moloen. Nåkka nytt e på vei, men det lukte gammelt.",
    "Ei lyspære blinka akkurat da navnet ditt blei nevnt. Strømmen har dårlig timing.",
    "En løs planke knirka uten vind. Nåkka under overflata vil bli hørt.",
    "Måsan flaug lavt over bensinpumpa. Nån ska langt på dårlig grunnlag.",
    "Ei svart fjær lå midt i kaffeskåla. Nån kjæm med et budskap de ikkje vil eie.",
    "Klokka på mottaket gikk baklengs i tre minutt. Nåkka gammelt får en ny runde.",
    "En tom sjark tuta ute i tåka. Nån ber om oppmerksomhet uten å vis sæ.",
    "Det kom ferskt sagflis fra et låst naust. Nån bygger en utvei i skjul.",
    "Fiskekassan sto på rekke med lokkan åpne. Nån har gjort plass før de veit ka som kommer.",
    "Ei lanterne brant i dagslys. Nån har glømt at faren allerede e synlig.",
    "Bensinpumpa ga én liter meir enn måleren. Du får nåkka du ikkje har betalt for, men regninga kjæm.",
    "Måsan sto på bakken mens kråkan tok taket. De vanlige reglan gjelder ikkje i dag.",
    "Det lukta røyk fra et kaldt naust. Nåkka ulme uten å ha fått navn.",
    "Postkassa va full av tang. Beskjeden kjæm fra et sted du ikkje kan svar.",
    "Ei blank sild lå på benken før mottaket åpna. Nån levere bevis før historia.",
    "Alle hundan i bygda bjeffa mot sør samtidig. Nåkka fremmed e allerede på vei.",
    "Det va fotspor på nymalt dørk. Nån har gått inn før tillatelsen kom.",
    "Et gammelt kompass pekte mot bua. Svaret ligg nærmere enn reisa.",
    "Fergebilletten din lå våt på kaia. En avgang du trudde va over, bli aktuell igjen.",
    "Kaffedampen gikk rett ned. Nåkka tungt presser sæ inn i bua.",
    "En fiskekrok hang i dørhåndtaket. Nån lokke dæ ut mens du prøv å gå inn.",
    "Vinsjen starta uten last. Nån bruk mye kraft på ingenting.",
    "Sola traff bærre én båt i havna. Nån bli sett før de e klar.",
    "Fyrlykta blinka mot land i stedet for sjøen. Varslet gjelder dem som allerede e hjemme.",
    "Det kom varmt vann fra kaldkrana i bua. Nåkka du trudde va avkjølt, lever fortsatt.",
    "En nøkkel sto i utsida av naustdøra. Nån har gjort det vanskeligere enn nødvendig.",
    "Heile fjæra va full av hvite steina. Fotsporan forsvinn ikkje med det første.",
    "En måse bar en bit av et fotografi. Fortida kommer tilbake i mindre bita.",
    "Tauet va vått midt på, men tørt i endan. Problemet ligg der ingen hold.",
    "Tre båta snudde før moloen. Det e klokt å vurdere retrett før alle gjør det.",
    "Ei klokke ringte fra ei tom rorbu. Nån venta på at du ska huske.",
    "Kjettingen va varm i vinterkulda. Nåkka har jobba i mørket.",
    "En fersk blomst lå på sløyebenken. Nåkka mildt kommer tel en hard plass.",
    "Alle vinduan i bua dugga samtidig. Sannheta e allerede innenfor veggan.",
    "En gammel radio i bua sa navnet ditt mellom to sendinga. Du bli omtalt der du ikkje e.",
    "Det lå salt i kaffeboksen. Nåkka bittert har blitt forveksla med det nødvendige.",
    "Ei bølge la en mynt på øverste trinn. Du får et valg som ser mindre ut enn det koster."
  ]
};

window.OTTAR_BUILD = {
  "source": "Google Sheet: Oraklet på Kaia – Tekstdatabase v1 komplett-2 / Season 3 – råtekst",
  "filter": "Season = 3 (including 3.0) AND Status = Approved AND Canon = Ja",
  "approvedRows": 1009,
  "poolCount": 31,
  "poolCounts": {
    "autumn": 20,
    "bamse": 48,
    "batmotor": 8,
    "christmas": 17,
    "easter": 15,
    "endings": 72,
    "faren": 16,
    "havet": 22,
    "johannes": 60,
    "kaffe": 6,
    "kaia": 100,
    "kaiaStories": 11,
    "livet": 8,
    "marta": 79,
    "midnattssol": 20,
    "morketid": 20,
    "morning": 18,
    "night": 14,
    "observations": 18,
    "openings": 72,
    "personal": 2,
    "ronny": 76,
    "signs": 88,
    "skrei": 22,
    "specials": 48,
    "spring": 20,
    "stikk": 3,
    "summer": 20,
    "vaeret": 2,
    "winter": 20,
    "wisdom": 64
  },
  "sourceIds": [
    "S3-0001",
    "S3-0003",
    "S3-0004",
    "S3-0006",
    "S3-0007",
    "S3-0008",
    "S3-0009",
    "S3-0010",
    "S3-0011",
    "S3-0013",
    "S3-0015",
    "S3-0016",
    "S3-0017",
    "S3-0018",
    "S3-0019",
    "S3-0020",
    "S3-0021",
    "S3-0022",
    "S3-0023",
    "S3-0026",
    "S3-0027",
    "S3-0030",
    "S3-0033",
    "S3-0038",
    "S3-0041",
    "S3-0042",
    "S3-0046",
    "S3-0047",
    "S3-0050",
    "S3-0051",
    "S3-0054",
    "S3-0055",
    "S3-0057",
    "S3-0058",
    "S3-0060",
    "S3-0063",
    "S3-0064",
    "S3-0069",
    "S3-0070",
    "S3-0071",
    "S3-0072",
    "S3-0074",
    "S3-0075",
    "S3-0077",
    "S3-0078",
    "S3-0081",
    "S3-0084",
    "S3-0085",
    "S3-0094",
    "S3-0095",
    "S3-0102",
    "S3-0105",
    "S3-0108",
    "S3-0111",
    "S3-0116",
    "S3-0122",
    "S3-0126",
    "S3-0127",
    "S3-0129",
    "S3-0130",
    "S3-0135",
    "S3-0137",
    "S3-0139",
    "S3-0144",
    "S3-0150",
    "S3-0152",
    "S3-0183",
    "S3-0188",
    "S3-0189",
    "S3-0191",
    "S3-0192",
    "S3-0195",
    "S3-0199",
    "S3-0200",
    "S3-0206",
    "S3-0213",
    "S3-0215",
    "S3-0216",
    "S3-0217",
    "S3-0218",
    "S3-0225",
    "S3-0228",
    "S3-0236",
    "S3-0245",
    "S3-0246",
    "S3-0248",
    "S3-0259",
    "S3-0271",
    "S3-0272",
    "S3-0275",
    "S3-0276",
    "S3-0277",
    "S3-0280",
    "S3-0281",
    "S3-0284",
    "S3-0287",
    "S3-0294",
    "S3-0295",
    "S3-0302",
    "S3-0308",
    "S3-0311",
    "S3-0318",
    "S3-0323",
    "S3-0324",
    "S3-0327",
    "S3-0332",
    "S3-0334",
    "S3-0337",
    "S3-0340",
    "S3-0350",
    "S3-0411",
    "S3-0416",
    "S3-0421",
    "S3-0432",
    "S3-0451",
    "S3-0468",
    "S3-0470",
    "S3-0471",
    "S3-0535",
    "S3-0550",
    "S3-0552",
    "S3-0555",
    "S3-0559",
    "S3-0562",
    "S3-0564",
    "S3-0570",
    "S3-0574",
    "S3-0575",
    "S3-0577",
    "S3-0578",
    "S3-0579",
    "S3-0581",
    "S3-0591",
    "S3-0594",
    "S3-0603",
    "S3-0608",
    "S3-0615",
    "S3-0616",
    "S3-0625",
    "S3-0626",
    "S3-0629",
    "S3-0630",
    "S3-0631",
    "S3-0641",
    "S3-0642",
    "S3-0646",
    "S3-0649",
    "S3-0652",
    "S3-0655",
    "S3-0659",
    "S3-0660",
    "S3-0663",
    "S3-0671",
    "S3-0674",
    "S3-0683",
    "S3-0684",
    "S3-0688",
    "S3-0690",
    "S3-0695",
    "S3-0700",
    "S3-0706",
    "S3-0710",
    "S3-0711",
    "S3-0712",
    "S3-0728",
    "S3-0735",
    "S3-0736",
    "S3-0737",
    "S3-0738",
    "S3-0749",
    "S3-0753",
    "S3-0754",
    "S3-0759",
    "S3-0760",
    "S3-0766",
    "S3-0800",
    "S3-0803",
    "S3-0806",
    "S3-0807",
    "S3-0808",
    "S3-0810",
    "S3-0811",
    "S3-0815",
    "S3-0816",
    "S3-0818",
    "S3-0820",
    "S3-0822",
    "S3-0825",
    "S3-0827",
    "S3-0830",
    "S3-0831",
    "S3-0837",
    "S3-0840",
    "S3-0846",
    "S3-0849",
    "S3-0850",
    "S3-0851",
    "S3-0853",
    "S3-0854",
    "S3-0858",
    "S3-0859",
    "S3-0860",
    "S3-0862",
    "S3-0866",
    "S3-0868",
    "S3-0869",
    "S3-0870",
    "S3-0872",
    "S3-0873",
    "S3-0875",
    "S3-0876",
    "S3-0880",
    "S3-0883",
    "S3-0887",
    "S3-0889",
    "S3-0890",
    "S3-0891",
    "S3-0893",
    "S3-0895",
    "S3-0896",
    "S3-0900",
    "S3-0901",
    "S3-0902",
    "S3-0904",
    "S3-0907",
    "S3-0910",
    "S3-0911",
    "S3-0914",
    "S3-0917",
    "S3-0919",
    "S3-0920",
    "S3-0922",
    "S3-0923",
    "S3-0924",
    "S3-0927",
    "S3-0928",
    "S3-0934",
    "S3-0935",
    "S3-0937",
    "S3-0938",
    "S3-0939",
    "S3-0941",
    "S3-0943",
    "S3-0949",
    "S3-0950",
    "S3-0953",
    "S3-0954",
    "S3-0955",
    "S3-0959",
    "S3-0960",
    "S3-0962",
    "S3-0963",
    "S3-0965",
    "S3-0967",
    "S3-0968",
    "S3-0970",
    "S3-0972",
    "S3-0973",
    "S3-0975",
    "S3-0976",
    "S3-0977",
    "S3-0980",
    "S3-0981",
    "S3-0983",
    "S3-0984",
    "S3-0987",
    "S3-0989",
    "S3-0992",
    "S3-0995",
    "S3-0997",
    "S3-1000",
    "S3-1005",
    "S3-1006",
    "S3-1007",
    "S3-1009",
    "S3-1010",
    "S3-1011",
    "S3-1012",
    "S3-1013",
    "S3-1015",
    "S3-1017",
    "S3-1018",
    "S3-1025",
    "S3-1027",
    "S3-1028",
    "S3-1029",
    "S3-1031",
    "S3-1034",
    "S3-1035",
    "S3-1037",
    "S3-1038",
    "S3-1039",
    "S3-1040",
    "S3-1041",
    "S3-1045",
    "S3-1049",
    "S3-1057",
    "S3-1061",
    "S3-1062",
    "S3-1065",
    "S3-1067",
    "S3-1069",
    "S3-1070",
    "S3-1072",
    "S3-1073",
    "S3-1074",
    "S3-1076",
    "S3-1077",
    "S3-1079",
    "S3-1080",
    "S3-1081",
    "S3-1082",
    "S3-1083",
    "S3-1084",
    "S3-1085",
    "S3-1087",
    "S3-1088",
    "S3-1090",
    "S3-1091",
    "S3-1092",
    "S3-1093",
    "S3-1095",
    "S3-1096",
    "S3-1099",
    "S3-1100",
    "S3-1102",
    "S3-1104",
    "S3-1105",
    "S3-1109",
    "S3-1110",
    "S3-1111",
    "S3-1116",
    "S3-1117",
    "S3-1118",
    "S3-1120",
    "S3-1121",
    "S3-1122",
    "S3-1123",
    "S3-1124",
    "S3-1125",
    "S3-1127",
    "S3-1128",
    "S3-1129",
    "S3-1130",
    "S3-1132",
    "S3-1134",
    "S3-1136",
    "S3-1137",
    "S3-1138",
    "S3-1139",
    "S3-1141",
    "S3-1142",
    "S3-1143",
    "S3-1144",
    "S3-1145",
    "S3-1146",
    "S3-1147",
    "S3-1149",
    "S3-1151",
    "S3-1152",
    "S3-1153",
    "S3-1154",
    "S3-1155",
    "S3-1156",
    "S3-1157",
    "S3-1158",
    "S3-1159",
    "S3-1160",
    "S3-1161",
    "S3-1162",
    "S3-1163",
    "S3-1168",
    "S3-1169",
    "S3-1170",
    "S3-1171",
    "S3-1172",
    "S3-1174",
    "S3-1176",
    "S3-1177",
    "S3-1178",
    "S3-1179",
    "S3-1180",
    "OK-0001",
    "OK-0003",
    "OK-0009",
    "OK-0015",
    "OK-0021",
    "OK-0028",
    "OK-0033",
    "OK-0039",
    "OK-0044",
    "OK-0047",
    "OK-0050",
    "OK-0055",
    "OK-0060",
    "OK-0065",
    "OK-0067",
    "OK-0068",
    "OK-0070",
    "OK-0075",
    "OK-0079",
    "OK-0081",
    "OK-0085",
    "OK-0088",
    "OK-0090",
    "OK-0095",
    "OK-0101",
    "OK-0107",
    "OK-0112",
    "OK-0117",
    "OK-0128",
    "OK-0139",
    "OK-0145",
    "OK-0156",
    "OK-0160",
    "OK-0161",
    "OK-0163",
    "OK-0165",
    "OK-0171",
    "OK-0175",
    "OK-0178",
    "OK-0204",
    "OK-0209",
    "OK-0214",
    "OK-0218",
    "OK-0219",
    "OK-0222",
    "OK-0226",
    "OK-0227",
    "OK-0228",
    "OK-0230",
    "OK-0231",
    "OK-0233",
    "OK-0234",
    "OK-0235",
    "OK-0237",
    "OK-0238",
    "OK-0239",
    "OK-0240",
    "OK-0242",
    "OK-0243",
    "OK-0244",
    "OK-0245",
    "OK-0246",
    "OK-0247",
    "OK-0249",
    "OK-0250",
    "OK-0251",
    "OK-0252",
    "OK-0253",
    "OK-0254",
    "OK-0255",
    "OK-0258",
    "OK-0259",
    "OK-0260",
    "OK-0261",
    "OK-0264",
    "OK-0265",
    "OK-0266",
    "OK-0267",
    "OK-0269",
    "OK-0270",
    "OK-0271",
    "OK-0273",
    "OK-0274",
    "OK-0275",
    "OK-0276",
    "OK-0277",
    "OK-0278",
    "OK-0279",
    "OK-0280",
    "OK-0282",
    "OK-0283",
    "OK-0286",
    "OK-0287",
    "OK-0288",
    "OK-0290",
    "OK-0292",
    "OK-0293",
    "OK-0294",
    "OK-0299",
    "OK-0301",
    "OK-0302",
    "OK-0303",
    "OK-0304",
    "OK-0305",
    "OK-0306",
    "OK-0307",
    "OK-0308",
    "OK-0309",
    "OK-0310",
    "OK-0311",
    "OK-0312",
    "OK-0313",
    "OK-0314",
    "OK-0315",
    "OK-0316",
    "OK-0317",
    "OK-0321",
    "OK-0322",
    "OK-0323",
    "OK-0325",
    "OK-0326",
    "OK-0327",
    "OK-0329",
    "OK-0330",
    "OK-0332",
    "OK-0334",
    "OK-0335",
    "OK-0336",
    "OK-0337",
    "OK-0339",
    "OK-0340",
    "OK-0341",
    "OK-0342",
    "OK-0344",
    "OK-0346",
    "OK-0347",
    "OK-0350",
    "OK-0352",
    "OK-0353",
    "OK-0354",
    "OK-0356",
    "OK-0357",
    "OK-0358",
    "OK-0359",
    "OK-0361",
    "OK-0364",
    "OK-0365",
    "OK-0366",
    "OK-0369",
    "OK-0372",
    "OK-0374",
    "OK-0375",
    "OK-0376",
    "OK-0377",
    "OK-0380",
    "OK-0382",
    "OK-0384",
    "OK-0387",
    "OK-0388",
    "OK-0389",
    "OK-0392",
    "OK-0397",
    "OK-0398",
    "OK-0400",
    "OK-0401",
    "OK-0404",
    "OK-0406",
    "OK-0409",
    "OK-0410",
    "OK-0412",
    "OK-0414",
    "OK-0415",
    "OK-0417",
    "OK-0425",
    "OK-0426",
    "OK-0428",
    "OK-0429",
    "OK-0430",
    "OK-0435",
    "OK-0436",
    "OK-0437",
    "OK-0439",
    "OK-0444",
    "OK-0445",
    "OK-0447",
    "OK-0451",
    "OK-0452",
    "OK-0453",
    "OK-0454",
    "OK-0455",
    "OK-0461",
    "OK-0462",
    "OK-0469",
    "OK-0470",
    "OK-0473",
    "OK-0479",
    "OK-0481",
    "OK-0482",
    "OK-0488",
    "OK-0489",
    "OK-0490",
    "OK-0491",
    "OK-0497",
    "OK-0501",
    "OK-0502",
    "OK-0504",
    "OK-0509",
    "OK-0510",
    "OK-0512",
    "OK-0513",
    "OK-0514",
    "OK-0520",
    "OK-0523",
    "OK-0529",
    "OK-0530",
    "OK-0531",
    "OK-0540",
    "OK-0546",
    "OK-0548",
    "OK-0550",
    "OK-0551",
    "OK-0552",
    "OK-0553",
    "OK-0554",
    "OK-0555",
    "OK-0560",
    "OK-0562",
    "OK-0564",
    "OK-0569",
    "OK-0571",
    "OK-0573",
    "OK-0579",
    "OK-0580",
    "OK-0581",
    "OK-0582",
    "OK-0587",
    "OK-0588",
    "OK-0589",
    "OK-0590",
    "OK-0597",
    "OK-0598",
    "OK-0600",
    "OK-0601",
    "OK-0603",
    "OK-0605",
    "S3-1200",
    "S3-1224",
    "S3-1256",
    "S3-1257",
    "S3-1258",
    "S3-1259",
    "S3-1260",
    "S3-1262",
    "S3-1263",
    "S3-1273",
    "S3-1275",
    "S3-1276",
    "S3-1277",
    "S3-1452",
    "S3-1458",
    "S3-1460",
    "S3-1465",
    "S3-1469",
    "S3-1472",
    "S3-1480",
    "S3-1482",
    "S3-1483",
    "S3-1486",
    "S3-1488",
    "S3-1497",
    "S3-1505",
    "S3-1558",
    "S3-1572",
    "S3-1580",
    "S3-1586",
    "S3-1607",
    "S3-1622",
    "S3-1657",
    "S3-1688",
    "S3-1691",
    "S3-1698",
    "S3-1701",
    "S3-1705",
    "S3-openings-051",
    "S3-openings-052",
    "S3-openings-053",
    "S3-openings-054",
    "S3-openings-055",
    "S3-openings-056",
    "S3-openings-058",
    "S3-openings-060",
    "S3-openings-061",
    "S3-openings-062",
    "S3-openings-063",
    "S3-openings-064",
    "S3-openings-066",
    "S3-openings-067",
    "S3-openings-069",
    "S3-openings-070",
    "S3-wisdom-051",
    "S3-wisdom-052",
    "S3-wisdom-053",
    "S3-wisdom-054",
    "S3-wisdom-055",
    "S3-wisdom-057",
    "S3-wisdom-058",
    "S3-wisdom-059",
    "S3-wisdom-060",
    "S3-wisdom-061",
    "S3-wisdom-062",
    "S3-wisdom-064",
    "S3-wisdom-066",
    "S3-wisdom-067",
    "S3-wisdom-068",
    "S3-wisdom-069",
    "S3-wisdom-070",
    "S3-endings-051",
    "S3-endings-052",
    "S3-endings-053",
    "S3-endings-054",
    "S3-endings-055",
    "S3-endings-056",
    "S3-endings-057",
    "S3-endings-058",
    "S3-endings-059",
    "S3-endings-060",
    "S3-endings-061",
    "S3-endings-062",
    "S3-endings-063",
    "S3-endings-064",
    "S3-endings-065",
    "S3-endings-067",
    "S3-endings-068",
    "S3-endings-069",
    "S3-endings-070",
    "S3-signs-007",
    "S3-signs-008",
    "S3-signs-009",
    "S3-signs-010",
    "S3-signs-011",
    "S3-signs-012",
    "S3-signs-013",
    "S3-signs-014",
    "S3-signs-015",
    "S3-signs-017",
    "S3-signs-018",
    "S3-signs-020",
    "S3-signs-021",
    "S3-signs-022",
    "S3-signs-023",
    "S3-signs-024",
    "S3-signs-025",
    "S3-signs-026",
    "S3-specials-005",
    "S3-specials-006",
    "S3-specials-007",
    "S3-specials-008",
    "S3-specials-009",
    "S3-specials-010",
    "S3-specials-011",
    "S3-specials-012",
    "S3-specials-013",
    "S3-specials-014",
    "S3-openings-071",
    "S3-openings-072",
    "S3-openings-073",
    "S3-openings-074",
    "S3-openings-075",
    "S3-openings-076",
    "S3-openings-077",
    "S3-openings-080",
    "S3-openings-081",
    "S3-openings-082",
    "S3-openings-083",
    "S3-openings-084",
    "S3-openings-085",
    "S3-openings-086",
    "S3-openings-087",
    "S3-openings-088",
    "S3-openings-089",
    "S3-openings-090",
    "S3-openings-091",
    "S3-openings-092",
    "S3-openings-093",
    "S3-openings-094",
    "S3-openings-095",
    "S3-openings-096",
    "S3-openings-097",
    "S3-openings-098",
    "S3-openings-099",
    "S3-openings-100",
    "S3-wisdom-071",
    "S3-wisdom-072",
    "S3-wisdom-073",
    "S3-wisdom-074",
    "S3-wisdom-075",
    "S3-wisdom-076",
    "S3-wisdom-077",
    "S3-wisdom-078",
    "S3-wisdom-079",
    "S3-wisdom-080",
    "S3-wisdom-081",
    "S3-wisdom-082",
    "S3-wisdom-083",
    "S3-wisdom-084",
    "S3-wisdom-085",
    "S3-wisdom-086",
    "S3-wisdom-087",
    "S3-wisdom-088",
    "S3-wisdom-089",
    "S3-wisdom-090",
    "S3-wisdom-091",
    "S3-wisdom-092",
    "S3-wisdom-093",
    "S3-wisdom-094",
    "S3-wisdom-095",
    "S3-wisdom-096",
    "S3-wisdom-097",
    "S3-wisdom-099",
    "S3-wisdom-100",
    "S3-wisdom-101",
    "S3-wisdom-102",
    "S3-wisdom-103",
    "S3-wisdom-104",
    "S3-wisdom-105",
    "S3-wisdom-106",
    "S3-wisdom-107",
    "S3-wisdom-108",
    "S3-wisdom-109",
    "S3-wisdom-110",
    "S3-endings-071",
    "S3-endings-072",
    "S3-endings-073",
    "S3-endings-074",
    "S3-endings-075",
    "S3-endings-076",
    "S3-endings-077",
    "S3-endings-078",
    "S3-endings-079",
    "S3-endings-080",
    "S3-endings-081",
    "S3-endings-082",
    "S3-endings-083",
    "S3-endings-085",
    "S3-endings-086",
    "S3-endings-087",
    "S3-endings-088",
    "S3-endings-089",
    "S3-endings-090",
    "S3-endings-091",
    "S3-endings-092",
    "S3-endings-093",
    "S3-endings-094",
    "S3-endings-095",
    "S3-endings-096",
    "S3-endings-097",
    "S3-endings-098",
    "S3-endings-099",
    "S3-endings-100",
    "S3-signs-027",
    "S3-signs-028",
    "S3-signs-029",
    "S3-signs-030",
    "S3-signs-031",
    "S3-signs-032",
    "S3-signs-033",
    "S3-signs-034",
    "S3-signs-035",
    "S3-signs-036",
    "S3-signs-037",
    "S3-signs-038",
    "S3-signs-039",
    "S3-signs-040",
    "S3-signs-042",
    "S3-signs-043",
    "S3-signs-044",
    "S3-signs-045",
    "S3-signs-046",
    "S3-signs-049",
    "S3-signs-050",
    "S3-signs-051",
    "S3-signs-052",
    "S3-signs-053",
    "S3-signs-054",
    "S3-signs-055",
    "S3-signs-056",
    "S3-signs-057",
    "S3-signs-058",
    "S3-signs-059",
    "S3-signs-060",
    "S3-signs-061",
    "S3-signs-062",
    "S3-signs-063",
    "S3-signs-064",
    "S3-signs-065",
    "S3-signs-066",
    "S3-specials-015",
    "S3-specials-016",
    "S3-specials-017",
    "S3-specials-018",
    "S3-specials-019",
    "S3-specials-020",
    "S3-specials-021",
    "S3-specials-022",
    "S3-specials-023",
    "S3-specials-024",
    "S3-specials-025",
    "S3-specials-026",
    "S3-specials-028",
    "S3-specials-029",
    "S3-specials-030",
    "S3-specials-031",
    "S3-specials-032",
    "S3-specials-034",
    "S3-openings-101",
    "S3-openings-103",
    "S3-openings-104",
    "S3-openings-105",
    "S3-openings-106",
    "S3-openings-107",
    "S3-openings-108",
    "S3-openings-109",
    "S3-openings-110",
    "S3-openings-111",
    "S3-openings-112",
    "S3-openings-113",
    "S3-openings-114",
    "S3-openings-115",
    "S3-openings-116",
    "S3-openings-117",
    "S3-openings-118",
    "S3-openings-119",
    "S3-openings-120",
    "S3-openings-121",
    "S3-openings-122",
    "S3-openings-123",
    "S3-openings-124",
    "S3-openings-125",
    "S3-openings-126",
    "S3-openings-127",
    "S3-openings-129",
    "S3-openings-130",
    "S3-wisdom-111",
    "S3-wisdom-114",
    "S3-wisdom-126",
    "S3-wisdom-127",
    "S3-wisdom-131",
    "S3-wisdom-140",
    "S3-wisdom-144",
    "S3-wisdom-147",
    "S3-endings-101",
    "S3-endings-102",
    "S3-endings-103",
    "S3-endings-104",
    "S3-endings-105",
    "S3-endings-106",
    "S3-endings-107",
    "S3-endings-108",
    "S3-endings-109",
    "S3-endings-111",
    "S3-endings-112",
    "S3-endings-113",
    "S3-endings-115",
    "S3-endings-116",
    "S3-endings-118",
    "S3-endings-119",
    "S3-endings-121",
    "S3-endings-123",
    "S3-endings-124",
    "S3-endings-125",
    "S3-endings-126",
    "S3-endings-127",
    "S3-endings-128",
    "S3-endings-130",
    "S3-signs-067",
    "S3-signs-068",
    "S3-signs-069",
    "S3-signs-070",
    "S3-signs-072",
    "S3-signs-073",
    "S3-signs-074",
    "S3-signs-076",
    "S3-signs-077",
    "S3-signs-079",
    "S3-signs-080",
    "S3-signs-081",
    "S3-signs-082",
    "S3-signs-083",
    "S3-signs-084",
    "S3-signs-085",
    "S3-signs-086",
    "S3-signs-087",
    "S3-signs-089",
    "S3-signs-091",
    "S3-signs-092",
    "S3-signs-093",
    "S3-signs-094",
    "S3-signs-095",
    "S3-signs-096",
    "S3-signs-097",
    "S3-signs-098",
    "S3-signs-099",
    "S3-signs-100",
    "S3-signs-101",
    "S3-signs-102",
    "S3-signs-103",
    "S3-signs-104",
    "S3-specials-035",
    "S3-specials-036",
    "S3-specials-037",
    "S3-specials-038",
    "S3-specials-039",
    "S3-specials-040",
    "S3-specials-041",
    "S3-specials-042",
    "S3-specials-043",
    "S3-specials-044",
    "S3-specials-045",
    "S3-specials-046",
    "S3-specials-047",
    "S3-specials-048",
    "S3-specials-049",
    "S3-specials-050",
    "S3-specials-051",
    "S3-specials-052",
    "S3-specials-053",
    "S3-specials-054"
  ]
};